{
  "about.blocks": "Мадэраваныя серверы",
  "about.contact": "Кантакт:",
  "about.default_locale": "Прадвызначаная",
  "about.disclaimer": "Mastodon - свабоднае праграмнае забеспячэнне, з адкрытым зыходным кодам, і гандлёвай маркай Mastodon GmbH.",
  "about.domain_blocks.no_reason_available": "Прычына недаступная",
  "about.domain_blocks.preamble": "Mastodon, у асноўным, дазваляе вам праглядаць кантэнт і ўзаемадзейнічаць з карыстальнікамі з іншых сервераў у федэсвету. Гэтыя выключэнні былі зроблены дакладна на гэтым серверы.",
  "about.domain_blocks.silenced.explanation": "Вы не будзеце бачыць профілі і змесціва гэтага серверу, калі не шукаеце іх мэтанакіравана ці не падпісаны на карыстальнікаў адтуль.",
  "about.domain_blocks.silenced.title": "Абмежаваны",
  "about.domain_blocks.suspended.explanation": "Ніякая інфармацыя з гэтага сервера не будзе апрацавана, захавана або абменена, узаемадзеянне або камунікацыя з карыстальнікамі гэтага сервера немагчымы.",
  "about.domain_blocks.suspended.title": "Прыпынены",
  "about.language_label": "Мова",
  "about.not_available": "Дадзеная інфармацыя не дасяжная на гэтым серверы.",
  "about.powered_by": "Дэцэнтралізаваная сацыяльная сетка, створаная {mastodon}",
  "about.rules": "Правілы сервера",
  "account.account_note_header": "Асабістая нататка",
  "account.activity": "Актыўнасць",
  "account.add_note": "Дадаць асабістую нататку",
  "account.add_or_remove_from_list": "Дадаць або выдаліць са спісаў",
  "account.badges.admin": "Адмін",
  "account.badges.blocked": "Заблакіраваны",
  "account.badges.bot": "Бот",
  "account.badges.domain_blocked": "Заблакіраваны дамен",
  "account.badges.group": "Група",
  "account.badges.muted": "Ігнаруецца",
  "account.badges.muted_until": "Ігнаруецца да {until}",
  "account.block": "Заблакіраваць @{name}",
  "account.block_domain": "Заблакіраваць дамен {domain}",
  "account.block_short": "Заблакіраваць",
  "account.blocked": "Заблакіраваны",
  "account.cancel_follow_request": "Скасаваць запыт на падпіску",
  "account.copy": "Скапіраваць спасылку на профіль",
  "account.direct": "Згадаць прыватна @{name}",
  "account.disable_notifications": "Не паведамляць мне пра публікацыі @{name}",
  "account.edit_note": "Рэдагаваць асабістую нататку",
  "account.edit_profile": "Рэдагаваць профіль",
  "account.edit_profile_short": "Рэдагаваць",
  "account.enable_notifications": "Апавяшчаць мяне пра допісы @{name}",
  "account.endorse": "Дадаць у \"Выбранае\" ў профілі",
  "account.familiar_followers_many": "Мае сярод падпісчыкаў {name1}, {name2}, і {othersCount, plural, one {яшчэ #-го чалавека, знаёмага Вам} few {яшчэ #-х чалавек, знаёмых Вам} many {яшчэ # людзей, знаёмых Вам} other {яшчэ # чалавек, знаёмых Вам}}",
  "account.familiar_followers_one": "Мае сярод падпісчыкаў {name1}",
  "account.familiar_followers_two": "Мае сярод падпісчыкаў {name1} і {name2}",
  "account.featured": "Выбранае",
  "account.featured.accounts": "Профілі",
  "account.featured.collections": "Калекцыі",
  "account.featured.new_collection": "Новая калекцыя",
  "account.field_overflow": "Паказаць усё змесціва",
  "account.filters.all": "Уся актыўнасць",
  "account.filters.boosts_toggle": "Паказваць пашырэнні",
  "account.filters.posts_boosts": "Допісы і пашырэнні",
  "account.filters.posts_only": "Допісы",
  "account.filters.posts_replies": "Допісы і адказы",
  "account.filters.replies_toggle": "Паказваць адказы",
  "account.follow": "Падпісацца",
  "account.follow_back": "Падпісацца ў адказ",
  "account.follow_back_short": "Падпісацца ў адказ",
  "account.follow_request": "Даслаць запыт на падпіску",
  "account.follow_request_cancel": "Скасаваць запыт",
  "account.follow_request_cancel_short": "Скасаваць",
  "account.follow_request_short": "Запыт",
  "account.followers": "Падпісчыкі",
  "account.followers.empty": "Ніхто пакуль не падпісаны на гэтага карыстальніка.",
  "account.followers_counter": "{count, plural, one {{counter} падпісчык} few {{counter} падпісчыкі} many {{counter} падпісчыкаў} other {{counter} падпісчыка}}",
  "account.followers_you_know_counter": "{count, plural, one {{counter} знаёмы Вам} few {{counter} знаёмыя Вам} other {{counter} знаёмых Вам}}",
  "account.following": "Падпіскі",
  "account.following_counter": "{count, plural, one {{counter} падпіска} few {{counter} падпіскі} many {{counter} падпісак} other {{counter} падпіскі}}",
  "account.follows.empty": "Карыстальнік ні на каго не падпісаны.",
  "account.follows_you": "Падпісаны на вас",
  "account.go_to_profile": "Перайсці да профілю",
  "account.hame.invalid_handle": "Ідэнтыфікатар недаступны",
  "account.hide_reblogs": "Схаваць пашырэнні ад @{name}",
  "account.in_memoriam": "У памяць.",
  "account.join_modal.day": "Дзень",
  "account.join_modal.me": "Вы далучыліся да {server}",
  "account.join_modal.me_anniversary": "З гадавінай! Вы далучыліся да {server}",
  "account.join_modal.me_today": "Сёння Ваш першы дзень на {server}!",
  "account.join_modal.other": "{name} далучыўся(-лася) да {server}",
  "account.join_modal.other_today": "Сёння першы дзень {name} на {server}!",
  "account.join_modal.share.celebrate": "Абагуліць урачысты допіс",
  "account.join_modal.share.intro": "Абагуліць допіс, каб прадставіцца",
  "account.join_modal.share.welcome": "Абагуліць прывітальны допіс",
  "account.join_modal.years": "{number, plural, one {# год} few {# гады} many {# гадоў} other {# гады}}",
  "account.joined_short": "Далучыўся",
  "account.languages": "Змяніць выбраныя мовы",
  "account.last_active": "Апошняя актыўнасць",
  "account.link_verified_on": "Права ўласнасці на гэтую спасылку праверана {date}",
  "account.locked_info": "Гэты ўліковы запіс пазначаны як схаваны. Уладальнік сам вырашае, хто можа падпісвацца на яго.",
  "account.media": "Медыя",
  "account.mention": "Згадаць @{name}",
  "account.menu.add_to_collection": "Дадаць у калекцыю…",
  "account.menu.add_to_list": "Дадаць у спіс…",
  "account.menu.block": "Заблакіраваць профіль",
  "account.menu.block_domain": "Заблакіраваць {domain}",
  "account.menu.copied": "Уліковы запіс скапіраваны ў буфер абмену",
  "account.menu.copy": "Скапіраваць",
  "account.menu.direct": "Згадаць прыватна",
  "account.menu.hide_reblogs": "Схаваць пашырэнні ў стужцы",
  "account.menu.mention": "Згадаць",
  "account.menu.mute": "Ігнараваць уліковы запіс",
  "account.menu.note.description": "Бачна толькі Вам",
  "account.menu.open_original_page": "Паказаць на {domain}",
  "account.menu.open_original_page_no_domain": "Праглядзець на арыгінальным серверы",
  "account.menu.remove_follower": "Выдаліць падпісчыка",
  "account.menu.report": "Паскардзіцца на профіль",
  "account.menu.share": "Абагуліць…",
  "account.menu.show_reblogs": "Паказваць пашырэнні ў стужцы",
  "account.menu.unblock": "Разблакіраваць уліковы запіс",
  "account.menu.unblock_domain": "Разблакіраваць {domain}",
  "account.menu.unmute": "Не ігнараваць уліковы запіс",
  "account.moved_to": "{name} указаў(-ла), што яго/яе новы ўліковы запіс цяпер:",
  "account.mute": "Ігнараваць @{name}",
  "account.mute_notifications_short": "Не апавяшчаць",
  "account.mute_short": "Ігнараваць",
  "account.muted": "Ігнаруецца",
  "account.mutual": "Вы падпісаныя адно на аднаго",
  "account.name.copy": "Скапір. ідэнтыфікатар",
  "account.name.help.domain": "{domain} — сервер, які ўтрымлівае профіль і допісы гэтага карыстальніка.",
  "account.name.help.domain_self": "{domain} — Ваш сервер, які ўтрымлівае Ваш профіль і допісы.",
  "account.name.help.footer": "Гэтак жа, як Вы можаце дасылаць электронныя лісты людзям, у якіх паштовыя скрыні ад іншых правайдараў, Вы можаце ўзаемадзейнічаць з людзьмі з іншых сервераў Mastodon і з усімі, хто карыстаецца іншымі праграмамі Федэральнага сусвету.",
  "account.name.help.header": "Ідэнтыфікатар карыстальніка падобны да адраса электроннай пошты",
  "account.name.help.invalid_explanation": "Гэта можа здарацца, калі карыстальнік змяняе сваё імя, і звычайна праходзіць праз нейкі час. Калі гэта працягвае паўтарацца, то прычынай можа быць недасяжнасць сервера або праблемы ў яго канфігурацыі.",
  "account.name.help.invalid_header": "Ідэнтыфікатар гэтага карыстальніка ў працэсе абнаўлення",
  "account.name.help.username": "{username} — імя карыстальніка гэтага ўліковага запісу на гэтым серверы. У некага на іншым серверы яно можа быць такім жа.",
  "account.name.help.username_self": "{username} — Вашае імя карыстальніка на гэтым серверы. У некага на іншым серверы яно можа быць такім жа.",
  "account.name_info": "Што гэта азначае?",
  "account.no_bio": "Апісанне адсутнічае.",
  "account.node_modal.callout": "Асабістыя нататкі бачныя толькі Вам.",
  "account.node_modal.edit_title": "Рэдагаваць асабістую нататку",
  "account.node_modal.error_unknown": "Немагчыма захаваць нататку",
  "account.node_modal.field_label": "Асабістая нататка",
  "account.node_modal.save": "Захаваць",
  "account.node_modal.title": "Дадаць асабістую нататку",
  "account.note.edit_button": "Змяніць",
  "account.note.title": "Асабістая нататка (бачная толькі Вам)",
  "account.open_original_page": "Адкрыць арыгінальную старонку",
  "account.pending": "Чакаецца",
  "account.posts": "Допісы",
  "account.remove_from_followers": "Выдаліць {name} з падпісчыкаў",
  "account.report": "Паскардзіцца на @{name}",
  "account.requested_follow": "{name} адправіў(-ла) запыт на падпіску",
  "account.share": "Абагуліць профіль @{name}",
  "account.show_reblogs": "Паказаць падштурхоўванні ад @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} допіс} few {{counter} допісы} many {{counter} допісаў} other {{counter} допісу}}",
  "account.timeline.pinned": "Замацавана",
  "account.timeline.pinned.view_all": "Паказаць усе замацаваныя допісы",
  "account.unblock": "Разблакіраваць @{name}",
  "account.unblock_domain": "Разблакіраваць дамен {domain}",
  "account.unblock_domain_short": "Разблакіраваць",
  "account.unblock_short": "Разблакіраваць",
  "account.unendorse": "Прыбраць з \"Выбранага\" ў профілі",
  "account.unfollow": "Адпісацца",
  "account.unmute": "Не ігнараваць @{name}",
  "account.unmute_notifications_short": "Апавяшчаць",
  "account.unmute_short": "Не ігнараваць",
  "account_edit.advanced_settings.bot_hint": "Пакажыце іншым, што гэты ўліковы запіс у асноўным выконвае аўтаматычныя дзеянні і можа не кантралявацца",
  "account_edit.advanced_settings.bot_label": "Аўтаматызаваны ўліковы запіс",
  "account_edit.advanced_settings.title": "Дадатковыя налады",
  "account_edit.bio.add_label": "Апісаць сябе",
  "account_edit.bio.edit_label": "Змяніць апісанне",
  "account_edit.bio.placeholder": "Коратка апішыце сябе, каб дапамагчы іншым пазнаць Вас.",
  "account_edit.bio.title": "Хто я",
  "account_edit.bio_modal.add_title": "Апісаць сябе",
  "account_edit.bio_modal.edit_title": "Змяніць апісанне",
  "account_edit.column_button": "Гатова",
  "account_edit.column_title": "Рэдагаваць профіль",
  "account_edit.custom_fields.add_label": "Дадаць поле",
  "account_edit.custom_fields.edit_label": "Рэдагаваць поле",
  "account_edit.custom_fields.placeholder": "Дадайце свае займеннікі, знешнія спасылкі ці нешта іншае, чым Вы хацелі б падзяліцца.",
  "account_edit.custom_fields.reorder_button": "Змяніць парадак палёў",
  "account_edit.custom_fields.tip_content": "Вы можаце лёгка дадаць даверу да свайго ўліковага запісу Mastodon пацвярджэннем спасылак на любы з Вашых сайтаў.",
  "account_edit.custom_fields.tip_title": "Падказка: Дадаванне пацверджаных спасылак",
  "account_edit.custom_fields.title": "Адвольныя палі",
  "account_edit.custom_fields.verified_hint": "Як мне дадаць пацверджаную спасылку?",
  "account_edit.display_name.add_label": "Дадаць бачнае імя",
  "account_edit.display_name.edit_label": "Рэдагаваць бачнае імя",
  "account_edit.display_name.placeholder": "Вашае бачнае імя — гэта імя, якое іншыя людзі бачаць у Вашым профілі і ў стужках.",
  "account_edit.display_name.title": "Бачнае імя",
  "account_edit.featured_hashtags.edit_label": "Дадаць хэштэгі",
  "account_edit.featured_hashtags.placeholder": "Дапамажыце іншым зразумець, якія тэмы Вас цікавяць, і атрымаць хуткі доступ да іх.",
  "account_edit.featured_hashtags.title": "Выбраныя хэштэгі",
  "account_edit.field_actions.delete": "Выдаліць поле",
  "account_edit.field_actions.edit": "Рэдагаваць поле",
  "account_edit.field_delete_modal.confirm": "Вы ўпэўненыя, што хочаце выдаліць гэтае адвольнае поле? Гэтае дзеянне будзе незваротным.",
  "account_edit.field_delete_modal.delete_button": "Выдаліць",
  "account_edit.field_delete_modal.title": "Выдаліць адвольнае поле?",
  "account_edit.field_edit_modal.add_title": "Дадаць адвольнае поле",
  "account_edit.field_edit_modal.discard_confirm": "Адхіліць",
  "account_edit.field_edit_modal.discard_message": "У Вас ёсць незахаваныя змены. Вы сапраўды хочаце адхіліць іх?",
  "account_edit.field_edit_modal.edit_title": "Рэдагаваць адвольнае поле",
  "account_edit.field_edit_modal.length_warning": "Перавышаны рэкамендаваны ліміт сімвалаў. Карыстальнікі мабільных прылад могуць не пабачыць Вашае поле цалкам.",
  "account_edit.field_edit_modal.link_emoji_warning": "Мы раім не ўжываць адвольныя эмодзі разам з url-спасылкамі. Адвольныя палі, якія ўтрымліваюць і тое, і другое, будуць адлюстраваныя выключна як тэкст, а не спасылкі, каб не блытаць карыстальнікаў.",
  "account_edit.field_edit_modal.name_hint": "Напрыклад, \"Асабісты Сайт\"",
  "account_edit.field_edit_modal.name_label": "Назва",
  "account_edit.field_edit_modal.url_warning": "Каб дадаць спасылку, калі ласка, дадайце {protocol} у яе пачатку.",
  "account_edit.field_edit_modal.value_hint": "Напрыклад, “https://example.me”",
  "account_edit.field_edit_modal.value_label": "Значэнне",
  "account_edit.field_reorder_modal.drag_cancel": "Перасоўванне адмененае. Поле {item} было павернутае на месца.",
  "account_edit.field_reorder_modal.drag_end": "Поле {item} было павернутае на месца.",
  "account_edit.field_reorder_modal.drag_instructions": "Каб змяніць парадак адвольных палёў, націсніце прабел або ўвод. Падчас перасоўвання карыстайцеся клавішамі са стрэлкамі, каб пасунуць поле ўверх ці ўніз. Націсніце прабел ці ўвод зноў, каб замацаваць поле на новым месцы, або націсніце Esc, каб скасаваць дзеянне.",
  "account_edit.field_reorder_modal.drag_move": "Поле {item} было перасунутае.",
  "account_edit.field_reorder_modal.drag_over": "Поле {item} было перасунутае над \"{over}\".",
  "account_edit.field_reorder_modal.drag_start": "Абранае поле \"{item}\".",
  "account_edit.field_reorder_modal.handle_label": "Перасунуць поле \"{item}\"",
  "account_edit.field_reorder_modal.title": "Перасунуць палі",
  "account_edit.image_alt_modal.add_title": "Дадаць альт. тэкст",
  "account_edit.image_alt_modal.details_content": "ЯК РАБІЦЬ: <ul> <li>Апішыце, як Вы выглядаеце на відарысе</li> <li>Апісвайце ад трэцяй асобы (напрыклад, “Алесь” замест \"я”)</li> <li>Будзьце сціслымі — некалькі слоў звычайна дастаткова</li> </ul> ЯК НЕ РАБІЦЬ: <ul> <li>Пачынаць з \"Фотаздымак...\" — гэта залішняе для чытачоў</li> </ul> ПРЫКЛАД: <ul> <li>“Алесь у вышыванцы і акулярах”</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Падказка: Альтэрнатыўны тэкст для фота профілю",
  "account_edit.image_alt_modal.edit_title": "Рэдагаваць альт. тэкст",
  "account_edit.image_alt_modal.text_hint": "Альтэрнатыўны тэкст дапамагае чытачам Вашага кантэнту лепш яго разумець.",
  "account_edit.image_alt_modal.text_label": "Альт. тэкст",
  "account_edit.image_delete_modal.confirm": "Вы ўпэўненыя, што хочаце выдаліць гэты відарыс? Гэтае дзеянне будзе незваротным.",
  "account_edit.image_delete_modal.delete_button": "Выдаліць",
  "account_edit.image_delete_modal.title": "Выдаліць відарыс?",
  "account_edit.image_edit.add_button": "Дадаць відарыс",
  "account_edit.image_edit.alt_add_button": "Дадаць альт. тэкст",
  "account_edit.image_edit.alt_edit_button": "Рэдагаваць альт. тэкст",
  "account_edit.image_edit.remove_button": "Прыбраць відарыс",
  "account_edit.image_edit.replace_button": "Замяніць відарыс",
  "account_edit.item_list.delete": "Выдаліць {name}",
  "account_edit.item_list.edit": "Рэдагаваць {name}",
  "account_edit.name_modal.add_title": "Дадаць бачнае імя",
  "account_edit.name_modal.edit_title": "Змяніць бачнае імя",
  "account_edit.profile_tab.button_label": "Змяніць",
  "account_edit.profile_tab.hint.description": "Гэтыя налады змяняюць тое, што бачаць карыстальнікі {server} у афіцыйных праграм, але гэта можа не ўплываць на карыстальнікаў іншых сервераў і неафіцыйных праграм.",
  "account_edit.profile_tab.hint.title": "Знешні выгляд можа адрознівацца",
  "account_edit.profile_tab.show_featured.description": "\"Выбранае\" — гэта неабавязковая ўкладка, куды вы можаце дадаць для паказу іншыя ўліковыя запісы.",
  "account_edit.profile_tab.show_featured.title": "Паказваць укладку \"Выбранае\"",
  "account_edit.profile_tab.show_media.description": "\"Медыя\" — гэта неабавязковая ўкладка, якая паказвае Вашыя допісы, у якіх ёсць відарысы і відэа.",
  "account_edit.profile_tab.show_media.title": "Паказваць укладку \"Медыя\"",
  "account_edit.profile_tab.show_media_replies.description": "Калі ўключыць, укладка \"Медыя\" будзе адлюстроўваць як Вашыя допісы, гэтак і Вашыя адказы на допісы іншых людзей.",
  "account_edit.profile_tab.show_media_replies.title": "Змяшчаць адказы ва ўкладцы \"Медыя\"",
  "account_edit.profile_tab.show_relations.description": "Паказвае іншым карыстальнікам у Вашым профілі Вашых падпісчыкаў і ўліковыя запісы, на якія Вы падпісаныя. Людзям, на якіх Вы падпісаныя, яны будуць бачныя заўсёды.",
  "account_edit.profile_tab.show_relations.title": "Паказваць падпісчыкаў і падпіскі’",
  "account_edit.profile_tab.subtitle": "Стварайце выгляд Вашага профілю для іншых.",
  "account_edit.profile_tab.title": "Налады адлюстравання профілю",
  "account_edit.save": "Захаваць",
  "account_edit.upload_modal.back": "Назад",
  "account_edit.upload_modal.done": "Гатова",
  "account_edit.upload_modal.next": "Далей",
  "account_edit.upload_modal.step_crop.zoom": "Маштаб",
  "account_edit.upload_modal.step_upload.button": "Агляд файлаў",
  "account_edit.upload_modal.step_upload.dragging": "Перацягн. сюды, каб запамп.",
  "account_edit.upload_modal.step_upload.header": "Выбраць відарыс",
  "account_edit.upload_modal.step_upload.hint": "Фармату WEBP, PNG, GIF або JPG, да {limit} МБ.{br}Відарыс будзе сціснуты да памеру {width}x{height} пікселяў.",
  "account_edit.upload_modal.title_add.avatar": "Дадаць фота профілю",
  "account_edit.upload_modal.title_add.header": "Дадаць фота вокладкі",
  "account_edit.upload_modal.title_replace.avatar": "Замяніць фота профілю",
  "account_edit.upload_modal.title_replace.header": "Замяніць фота вокладкі",
  "account_edit.verified_modal.details": "Дадайце даверу да Вашага профілю Mastodon, пацвярджэннем спасылак на ўласныя сайты. Вось як гэта працуе:",
  "account_edit.verified_modal.invisible_link.details": "Дадайце спасылку ў свой загаловак. Важнай часткай з'яўляецца rel=\"me\", яна прадухіляе выдачу сябе за іншую асобу на сайтах з карыстальніцкім кантэнтам. Вы нават можаце выкарыстоўваць тэг link у загалоўку старонкі замест {tag}, але HTML код павінен быць даступным без выканання JavaScript.",
  "account_edit.verified_modal.invisible_link.summary": "Як мне зрабіць спасылку нябачнай?",
  "account_edit.verified_modal.step1.header": "Скапіруйце HTML код знізу і ўстаўце яго ў загаловак свайго сайту",
  "account_edit.verified_modal.step2.details": "Калі Вы ўжо дадалі свой сайт у якасці адвольнага поля, Вам спатрэбіцца яго выдаліць і зноў дадаць, каб запусціць верыфікацыю.",
  "account_edit.verified_modal.step2.header": "Дадаць свой сайт як адвольнае поле",
  "account_edit.verified_modal.title": "Як дадаць пацверджаную спасылку",
  "account_edit_tags.add_tag": "Дадаць #{tagName}",
  "account_edit_tags.column_title": "Рэдагаваць тэгі",
  "account_edit_tags.help_text": "Выбраныя хэштэгі дапамагаюць карыстальнікам знаходзіць Ваш профіль і ўзаемадзейнічаць з ім. Яны дзейнічаюць як фільтры пры праглядзе актыўнасці на Вашай старонцы.",
  "account_edit_tags.max_tags_reached": "У Вас максімальная колькасць выбраных хэштэгаў.",
  "account_edit_tags.search_placeholder": "Увядзіце хэштэг…",
  "account_edit_tags.suggestions": "Прапановы:",
  "account_edit_tags.tag_status_count": "{count, plural, one {допіс} few {допісы} many {допісаў} other {допісаў}}",
  "account_list.hidden_notice": "Гэта бачыце толькі Вы. Каб паказаць гэты спіс іншым, перайдзіце ў <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural,one {# уліковы запіс} few{# уліковыя запісы} other {# уліковых запісаў}}",
  "admin.dashboard.daily_retention": "Штодзённы паказчык утрымання карыстальнікаў пасля рэгістрацыі",
  "admin.dashboard.monthly_retention": "Штомесячны паказчык утрымання карыстальнікаў пасля рэгістрацыі",
  "admin.dashboard.retention.average": "Сярэдняе",
  "admin.dashboard.retention.cohort": "Месяц рэгістрацыі",
  "admin.dashboard.retention.cohort_size": "Новыя карыстальнікі",
  "admin.impact_report.instance_accounts": "Профілі ўліковых запісаў, якія будуць выдаленыя",
  "admin.impact_report.instance_followers": "Падпісчыкі, якіх страцяць нашыя карыстальнікі",
  "admin.impact_report.instance_follows": "Падпісчыкі, якіх могуць страціць іх карыстальнікі",
  "admin.impact_report.title": "Агульны ўплыў",
  "alert.need_reload.message": "Mastodon быў абноўлены. Некаторыя функцыі могуць працаваць некарэктна, пакуль Вы не перазагрузіце старонку.",
  "alert.rate_limited.message": "Калі ласка, паспрабуйце праз {retry_time, time, medium}.",
  "alert.rate_limited.title": "Ліміт перавышаны",
  "alert.unexpected.message": "Узнікла нечаканая памылка.",
  "alert.unexpected.title": "Вой!",
  "alt_text_badge.title": "Альтэрнатыўны тэкст",
  "alt_text_modal.add_alt_text": "Дадаць альтэрнатыўны тэкст",
  "alt_text_modal.add_text_from_image": "Дадаць тэкст з відарыса",
  "alt_text_modal.cancel": "Скасаваць",
  "alt_text_modal.change_thumbnail": "Змяніць мініяцюру",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Апішыце гэта людзям з праблемамі са слыхам…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Апішыце гэта людзям з праблемамі са зрокам…",
  "alt_text_modal.done": "Гатова",
  "announcement.announcement": "Аб'ява",
  "annual_report.announcement.action_build": "Старыць мне Вынікадон",
  "annual_report.announcement.action_dismiss": "Не, дзякуй",
  "annual_report.announcement.action_view": "Паглядзець мой Вынікадон",
  "annual_report.announcement.description": "Даведайцеся больш пра Вашыя ўзаемадзеянні ў Mastodon за апошні год.",
  "annual_report.announcement.title": "Вынікадон {year} ужо тут",
  "annual_report.nav_item.badge": "Новы",
  "annual_report.shared_page.donate": "Ахвяраваць",
  "annual_report.shared_page.footer": "З {heart} згенеравала каманда Mastodon",
  "annual_report.shared_page.footer_server_info": "{username} карыстаецца {domain}, адной са шматлікіх супольнасцяў, якія ўтрымлівае Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "{name} увесь час паляваў(-ла) на допісы, каб пашырыць іх і разгаласіць аб іх аўтарах ідэальнымі стрэламі.",
  "annual_report.summary.archetype.booster.desc_self": "Вы ўвесь час палявалі на допісы, каб пашырыць іх і разгаласіць аб іх аўтарах ідэальнымі стрэламі.",
  "annual_report.summary.archetype.booster.name": "Лучнік",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Мы ведаем, што {name} быў(-ла) дзесьці тут і па-свойму атрымліваў(-ла) асалоду ад Mastodon.",
  "annual_report.summary.archetype.lurker.desc_self": "Мы ведаем, што Вы былі дзесьці тут і па-свойму атрымлівалі асалоду ад Mastodon.",
  "annual_report.summary.archetype.lurker.name": "Стоік",
  "annual_report.summary.archetype.oracle.desc_public": "Новых допісаў у {name} было больш, чым адказаў, і гэткім чынам ён (яна) пакідаў(-ла) Mastodon свежым і накіраваным у будучыню.",
  "annual_report.summary.archetype.oracle.desc_self": "Новых допісаў у Вас было больш, чым адказаў, і гэткім чынам Вы пакідалі Mastodon свежым і накіраваным у будучыню.",
  "annual_report.summary.archetype.oracle.name": "Аракул",
  "annual_report.summary.archetype.pollster.desc_public": "Сярод допісаў {name} было найбольш апытанак, якімі ён (яна) падымаў(-ла) цікаўнасць у Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Сярод Вашых допісаў было найбольш апытанак, якімі Вы падымалі цікаўнасць у Mastodon.",
  "annual_report.summary.archetype.pollster.name": "Даследчык",
  "annual_report.summary.archetype.replier.desc_public": "{name} часта адказваў(-ла) на допісы іншых людзей, апыляючы Mastodon новымі дыскусіямі.",
  "annual_report.summary.archetype.replier.desc_self": "Вы часта адказвалі на допісы іншых людзей, апыляючы Mastodon новымі дыскусіямі.",
  "annual_report.summary.archetype.replier.name": "Матыль",
  "annual_report.summary.archetype.reveal": "Раскрыць мой архетып",
  "annual_report.summary.archetype.reveal_description": "Дзякуй за тое, што Вы былі і застаяцеся часткай Mastodon! Час даведацца, які архетып Вы ўвасобілі ў {year}-ым годзе.",
  "annual_report.summary.archetype.title_public": "Архетып {name}",
  "annual_report.summary.archetype.title_self": "Ваш архетып",
  "annual_report.summary.close": "Закрыць",
  "annual_report.summary.copy_link": "Скапіраваць",
  "annual_report.summary.followers.new_followers": "{count, plural, one {новы падпісчык} few {новыя падпісчыкі} other {новых падпісчыкаў}}",
  "annual_report.summary.highlighted_post.boost_count": "Гэты допіс пашырылі {count, plural, one {адзін раз} few {# разы} other {# разоў}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Гэты допіс упадабалі {count, plural, one {адзін раз} few {# разы} other {# разоў}}.",
  "annual_report.summary.highlighted_post.reply_count": "На гэты допіс адказалі {count, plural, one {адзін раз} few {# разы} other {# разоў}}.",
  "annual_report.summary.highlighted_post.title": "Самы папулярны допіс",
  "annual_report.summary.most_used_app.most_used_app": "праграма, якой карысталіся найчасцей",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "хэштэг, якім карысталіся найчасцей",
  "annual_report.summary.most_used_hashtag.used_count": "Вы выкарысталі гэты хэштэг у {count, plural, one {адным допісе} other {# допісах}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} выкарыстаў(-ла) гэты хэштэг у {count, plural, one {адным допісе} other {# допісах}}.",
  "annual_report.summary.new_posts.new_posts": "новыя допісы",
  "annual_report.summary.percentile.text": "<topLabel>Гэта падымае Вас у топ</topLabel><percentage></percentage><bottomLabel> карыстальнікаў {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "КДБ пра гэта не даведаецца.",
  "annual_report.summary.share_elsewhere": "Падзяліцца ў іншым месцы",
  "annual_report.summary.share_message": "Мой архетып – {archetype}!",
  "annual_report.summary.share_on_mastodon": "Падзяліцца ў Mastodon",
  "attachments_list.unprocessed": "(неапрацаваны)",
  "audio.hide": "Схаваць аўдыя",
  "block_modal.no_collections": "Вы не зможаце дадаць адно аднаго ў калекцыі. Пры патрэбе вы будзеце выдаленыя з ужо існых калекцый абаіх.",
  "block_modal.remote_users_caveat": "Мы папросім сервер {domain} паважаць Ваш выбар. Аднак гэта не гарантуецца, паколькі некаторыя серверы могуць апрацоўваць блакіроўкі іншым чынам. Публічныя паведамленні могуць заставацца бачнымі для ананімных карыстальнікаў.",
  "block_modal.show_less": "Паказаць меньш",
  "block_modal.show_more": "Паказаць больш",
  "block_modal.they_cant_mention": "Вы не зможаце згадваць, падпісвацца або цытаваць адно аднаго.",
  "block_modal.they_cant_see_posts": "Гэты карыстальнік не зможа ўбачыць Ваш кантэнт, а Вы не зможаце ягоны.",
  "block_modal.they_will_know": "Карыстальнік убачыць, што адбылася блакіроўка.",
  "block_modal.title": "Заблакіраваць карыстальніка?",
  "block_modal.you_wont_see_mentions": "Вы не ўбачыце допісы іншых людзей, дзе гэты карыстальнік згадваецца.",
  "boost_modal.combo": "Націсніце {combo}, каб прапусціць наступным разам",
  "boost_modal.reblog": "Пашырыць допіс?",
  "boost_modal.undo_reblog": "Прыбраць допіс?",
  "bundle_column_error.copy_stacktrace": "Скапіраваць справаздачу пра памылку",
  "bundle_column_error.error.body": "Запытаная старонка не можа быць адлюстраваная. Гэта магло стацца праз хібу ў нашым кодзе, або праз памылку сумяшчальнасці з браўзерам.",
  "bundle_column_error.error.title": "Халера!",
  "bundle_column_error.network.body": "Падчас загрузкі старонкі адбылася памылка. Гэта магло адбыцца праз часовую праблему з вашым інтэрнэтам, або з серверам.",
  "bundle_column_error.network.title": "Памылка сеткі",
  "bundle_column_error.retry": "Паспрабуйце зноў",
  "bundle_column_error.return": "Да стужкі",
  "bundle_column_error.routing.body": "Запытаная старонка не знойдзена. Вы ўпэўнены, што URL у адрасным радку правільны?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Закрыць",
  "bundle_modal_error.message": "Падчас загрузкі гэтага экрана штосьці пайшло не так.",
  "bundle_modal_error.retry": "Паспрабуйце зноў",
  "callout.dismiss": "Адхіліць",
  "carousel.current": "<sr>Слайд</sr> {current, number} з {max, number}",
  "carousel.slide": "Слайд {current, number} з {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} рэкамендаваных сімвалаў",
  "character_counter.required": "{currentLength}/{maxLength} сімвалаў",
  "closed_registrations.other_server_instructions": "Паколькі Mastodon дэцэнтралізаваны, вы можаце стварыць уліковы запіс на іншым серверы і працягваць узаемадзейнічаць з ім.",
  "closed_registrations_modal.description": "Стварэнне ўліковага запісу на {domain} цяпер немагчыма. Заўважце, што няма неабходнасці мець уліковы запіс менавіта на {domain}, каб выкарыстоўваць Mastodon.",
  "closed_registrations_modal.find_another_server": "Знайсці іншы сервер",
  "closed_registrations_modal.preamble": "Mastodon дэцэнтралізаваны, так што дзе б вы ні стварылі ўліковы запіс, вы зможаце падпісвацца і камунікаваць з кім хочаце на гэтым серверы. Вы нават можаце стварыць свой!",
  "closed_registrations_modal.title": "Рэгістрацыя ў Mastodon",
  "collection.share_modal.share_link_label": "Абагуліць спасылку",
  "collection.share_modal.share_via_post": "Апублікаваць у Mastodon",
  "collection.share_modal.share_via_system": "Падзяліцца ў…",
  "collection.share_modal.title": "Падзяліцца калекцыяй",
  "collection.share_modal.title_new": "Падзяліцеся сваёй калекцыяй!",
  "collection.share_template_other": "Глядзі, якая класная калекцыя:",
  "collection.share_template_own": "Глядзі, у мяне новая калекцыя:",
  "collections.account_count": "{count, plural,one {# уліковы запіс} few {# уліковыя запісы} other {# уліковых запісаў}}",
  "collections.accounts.empty_description": "Дадайце да {count} уліковых запісаў",
  "collections.accounts.empty_editor_title": "У гэтай калекцыі пакуль нікога няма",
  "collections.accounts.empty_title": "Гэтая калекцыя пустая",
  "collections.add_to_collection": "Дадаць {name} у калекцыі",
  "collections.block_collection_owner": "Заблакіраваць профіль",
  "collections.by_account": "ад {account_handle}",
  "collections.collection_description": "Апісанне",
  "collections.collection_language": "Мова",
  "collections.collection_language_none": "Няма",
  "collections.collection_name": "Назва",
  "collections.collection_topic": "Тэма",
  "collections.confirm_account_removal": "Упэўненыя, што хочаце прыбраць гэты ўліковы запіс з гэтай калекцыі?",
  "collections.content_warning": "Папярэджанне аб змесціве",
  "collections.continue": "Працягнуць",
  "collections.copy_link": "Капіяваць спасылку",
  "collections.copy_link_confirmation": "Калекцыя скапіяваная ў буфер абмену",
  "collections.create.accounts_title": "Каго Вы ўключыце ў гэтую калекцыю?",
  "collections.create.basic_details_title": "Асноўныя звесткі",
  "collections.create.steps": "Крок {step}/{total}",
  "collections.create_collection": "Стварыць калекцыю",
  "collections.create_new_collection": "Стварыць новую калекцыю",
  "collections.delete_collection": "Выдаліць калекцыю",
  "collections.description_length_hint": "Максімум 100 сімвалаў",
  "collections.detail.author_added_you_on_date": "{author} дадаў(-ла) Вас {date}",
  "collections.detail.loading": "Загружаецца калекцыя…",
  "collections.detail.revoke_inclusion": "Прыбраць сябе",
  "collections.detail.sensitive_content": "Адчувальнае змесціва",
  "collections.detail.sensitive_note": "Апісанне і ўліковыя запісы могуць не пасаваць усім гледачам.",
  "collections.detail.share": "Падзяліцца гэтай калекцыяй",
  "collections.detail.you_are_in_this_collection": "Вас уключылі ў гэтую калекцыю",
  "collections.edit_details": "Рэдагаваць падрабязнасці",
  "collections.error_loading_collections": "Адбылася памылка падчас загрузкі гэтых калекцый.",
  "collections.hidden_accounts_description": "Вы заблакіравалі або ігнаруеце {count, plural, one {гэтага карыстальніка} other {гэтых карыстальнікаў}}",
  "collections.hidden_accounts_link": "{count, plural, one {# схаваны ўліковы запіс} few {# схаваныя ўліковыя запісы} other {# схаваных уліковых запісаў}}",
  "collections.hints.accounts_counter": "{count}/{max} уліковых запісаў",
  "collections.last_updated_at": "Апошняе абнаўленне: {date}",
  "collections.list.collections_with_count": "{count, plural, one {калекцыя} few {калекцыі} many {калекцыяў} other {калекцыі}}",
  "collections.list.created_by_author": "Створаныя {name}",
  "collections.list.created_by_you": "Створаныя Вамі",
  "collections.list.featuring_you": "У якіх ёсць Вы",
  "collections.manage_accounts": "Кіраванне ўліковымі запісамі",
  "collections.mark_as_sensitive": "Пазначыць як адчувальную",
  "collections.mark_as_sensitive_hint": "Схаваць апісанне калекцыі і ўліковыя запісы за банерам з папярэджаннем. Назва калекцыі застанецца бачнай.",
  "collections.maximum_collection_count_description": "Ваш сервер дазваляе ствараць да {count} калекцый.",
  "collections.maximum_collection_count_reached": "Вы стварылі максімальную колькасць калекцый",
  "collections.name_length_hint": "Максімум 40 сімвалаў",
  "collections.new_collection": "Новая калекцыя",
  "collections.pending_accounts.message": "Уліковыя запісы могуць чакацца, пакуль мы не атрымаем адказ ад карыстальніка або яго сервера. Яны бачныя толькі Вам.",
  "collections.pending_accounts.title": "Чаму некаторыя ўліковыя запісы чакаюцца?",
  "collections.remove_account": "Выдаліць",
  "collections.report_collection": "Паскардзіцца на гэту калекцыю",
  "collections.revoke_collection_inclusion": "Прыбраць сябе з гэтай калекцыі",
  "collections.revoke_inclusion.confirmation": "Вас прыбралі з \"{collection}\"",
  "collections.revoke_inclusion.error": "Адбылася памылка, калі ласка, спрабуйце яшчэ раз пазней.",
  "collections.search_accounts_label": "Адшукайце ўліковы запіс, каб дадаць яго сюды",
  "collections.search_accounts_max_reached": "Вы дадалі максімальную колькасць уліковых запісаў",
  "collections.sensitive": "Адчувальная",
  "collections.share_short": "Абагуліць",
  "collections.sort_alphabetical": "Алфавіце",
  "collections.sort_by": "Сартаваць па:",
  "collections.sort_date_added": "Даце дадавання",
  "collections.sort_last_active": "Апошняй актыўнасці",
  "collections.sort_most_followers": "Колькасці падпісчыкаў",
  "collections.suggestions.can_not_add": "Немагчыма дадаць",
  "collections.suggestions.can_not_add_desc": "Магчыма, гэтыя ўліковыя запісы схаваныя ад рэкамендацый або знаходзяцца на серверы, які не падтрымлівае калекцыі.",
  "collections.suggestions.must_follow": "Патрабуецца падпіска",
  "collections.suggestions.must_follow_desc": "Гэтыя ўліковыя запісы разглядаюць усе запыты на падпіску. Падпісчыкі могуць дадаваць іх у калекцыі.",
  "collections.topic_hint": "Дадайце хэштэг, які дапаможа іншым зразумець галоўную тэму гэтай калекцыі.",
  "collections.topic_special_chars_hint": "Спецыяльныя сімвалы будуць прыбраныя пры захаванні",
  "collections.unlisted_collections_description": "Яны не паказваюцца ў Вашым профілі іншым карыстальнікам. Іх можа пабачыць любы, хто мае спасылку на іх.",
  "collections.unlisted_collections_with_count": "Схаваныя калекцыі ({count})",
  "collections.view_collection": "Глядзець калекцыю",
  "collections.visibility_public": "Публічная",
  "collections.visibility_public_hint": "Можна знайсці ў пошуку і іншых месцах, дзе з'яўляюцца рэкамендацыі.",
  "collections.visibility_title": "Бачнасць",
  "collections.visibility_unlisted": "Схаваная",
  "collections.visibility_unlisted_hint": "Бачная ўсім, у каго ёсць спасылка. Схаваная ад пошуку і рэкамендацый.",
  "column.about": "Пра нас",
  "column.blocks": "Заблакіраваныя карыстальнікі",
  "column.bookmarks": "Закладкі",
  "column.community": "Лакальная стужка",
  "column.create_list": "Стварыць спіс",
  "column.direct": "Прыватныя згадванні",
  "column.directory": "Праглядзець профілі",
  "column.domain_blocks": "Заблакіраваныя дамены",
  "column.edit_list": "Рэдагаваць спіс",
  "column.favourites": "Упадабанае",
  "column.firehose": "Стужкі",
  "column.firehose_local": "Жывая стужка гэтага сервера",
  "column.firehose_singular": "Жывая стужка",
  "column.follow_requests": "Запыты на падпіску",
  "column.home": "Галоўная",
  "column.list_members": "Кіраванне ўдзельнікамі спіса",
  "column.lists": "Спісы",
  "column.mutes": "Ігнараваныя карыстальнікі",
  "column.notifications": "Апавяшчэнні",
  "column.other_collections": "Калекцыі {name}",
  "column.pins": "Замацаваныя допісы",
  "column.public": "Інтэграваная стужка",
  "column.your_collections": "Вашы калекцыі",
  "column_back_button.label": "Назад",
  "column_header.hide_settings": "Схаваць налады",
  "column_header.moveLeft_settings": "Пасунуць слупок улева",
  "column_header.moveRight_settings": "Пасунуць слупок управа",
  "column_header.pin": "Замацаваць",
  "column_header.show_settings": "Паказаць налады",
  "column_header.unpin": "Адмацаваць",
  "column_search.cancel": "Скасаваць",
  "combobox.close_results": "Закрыць вынікі",
  "combobox.loading": "Загрузка",
  "combobox.no_results_found": "Няма вынікаў па гэтым пошукавым запыце",
  "combobox.open_results": "Адкрыць вынікі",
  "combobox.results_available": "{count, plural, one {# прапанова даступная} few {# прапановы даступныя} other {# прапаноў даступныя}}. Выкарыстоўвайце кнопкі стрэлак уверх і ўніз для перасоўвання. Націсніце Enter, каб выбраць.",
  "community.column_settings.local_only": "Толькі лакальныя",
  "community.column_settings.media_only": "Толькі медыя",
  "community.column_settings.remote_only": "Толькі дыстанцыйна",
  "compose.error.blank_post": "Допіс не можа быць пустым.",
  "compose.language.change": "Змяніць мову",
  "compose.language.search": "Шукаць мовы...",
  "compose.published.body": "Допіс апублікаваны.",
  "compose.published.open": "Адкрыць",
  "compose.saved.body": "Допіс захаваны.",
  "compose_form.direct_message_warning_learn_more": "Даведацца больш",
  "compose_form.encryption_warning": "Допісы ў Mastodon не абароненыя скразным шыфраваннем. Не дзяліцеся ніякай канфідэнцыяльнай інфармацыяй праз Mastodon.",
  "compose_form.hashtag_warning": "Гэты допіс не будзе паказаны пад аніякім хэштэгам, бо ён не публічны. Толькі публічныя допісы можна знайсці па хэштэгу.",
  "compose_form.lock_disclaimer": "Ваш уліковы запіс не {locked}. Усе могуць падпісацца на вас, каб бачыць допісы толькі для падпісчыкаў.",
  "compose_form.lock_disclaimer.lock": "закрыты",
  "compose_form.placeholder": "Што ў вас новага?",
  "compose_form.poll.duration": "Працягласць апытання",
  "compose_form.poll.multiple": "Множны выбар",
  "compose_form.poll.option_placeholder": "Варыянт {number}",
  "compose_form.poll.single": "Адзін варыянт",
  "compose_form.poll.switch_to_multiple": "Змяніце апытанне, каб дазволіць некалькі варыянтаў адказу",
  "compose_form.poll.switch_to_single": "Змяніце апытанне, каб дазволіць адзіны варыянт адказу",
  "compose_form.poll.type": "Стыль",
  "compose_form.publish": "Даслаць",
  "compose_form.reply": "Адказаць",
  "compose_form.save_changes": "Абнавіць",
  "compose_form.spoiler.marked": "Выдаліць папярэджанне аб змесціве",
  "compose_form.spoiler.unmarked": "Дадаць папярэджанне аб змесціве",
  "compose_form.spoiler_placeholder": "Папярэджанне аб змесціве (неабавязкова)",
  "confirmation_modal.cancel": "Скасаваць",
  "confirmations.block.confirm": "Заблакіраваць",
  "confirmations.delete.confirm": "Выдаліць",
  "confirmations.delete.message": "Вы ўпэўненыя, што хочаце выдаліць гэты допіс?",
  "confirmations.delete.title": "Выдаліць допіс?",
  "confirmations.delete_collection.confirm": "Выдаліць",
  "confirmations.delete_collection.message": "Гэтае дзеянне немагчыма скасаваць.",
  "confirmations.delete_collection.title": "Выдаліць \"{name}\"?",
  "confirmations.delete_list.confirm": "Выдаліць",
  "confirmations.delete_list.message": "Вы ўпэўненыя, што хочаце беззваротна выдаліць гэты спіс?",
  "confirmations.delete_list.title": "Выдаліць спіс?",
  "confirmations.discard_draft.confirm": "Адмовіцца і працягнуць",
  "confirmations.discard_draft.edit.cancel": "Працягнуць рэдагаванне",
  "confirmations.discard_draft.edit.message": "Калі працягнуць, то ўсе змены, што Вы зрабілі ў гэтым допісе, будуць адмененыя.",
  "confirmations.discard_draft.edit.title": "Адмовіцца ад змен у Вашым допісе?",
  "confirmations.discard_draft.post.cancel": "Працягнуць чарнавік",
  "confirmations.discard_draft.post.message": "Калі працягнуць, то допіс, які Вы зараз пішаце, не будзе апублікаваны.",
  "confirmations.discard_draft.post.title": "Скасаваць чарнавік?",
  "confirmations.discard_edit_media.confirm": "Адмяніць",
  "confirmations.discard_edit_media.message": "У вас ёсць незахаваныя змены ў апісанні або прэв'ю, усе роўна скасаваць іх?",
  "confirmations.follow_to_list.confirm": "Падпісацца і дадаць у спіс",
  "confirmations.follow_to_list.message": "Вам трэба падпісацца на {name}, каб дадаць яго/яе ў спіс.",
  "confirmations.follow_to_list.title": "Падпісацца на карыстальніка?",
  "confirmations.hide_featured_tab.confirm": "Схаваць укладку",
  "confirmations.hide_featured_tab.intro": "Вы можаце змяніць гэтую наладу ў любы момант у <i>Рэдагаваць профіль > Налады ўкладкі профілю</i>.",
  "confirmations.hide_featured_tab.message": "Гэтае дзеянне схавае ўкладку ад карыстальнікаў {serverName} і іншых сервераў з апошняй версіяй Mastodon. Яе адлюстраванне на іншых серверах можа адрознівацца.",
  "confirmations.hide_featured_tab.title": "Схаваць укладку \"Выбранае\"?",
  "confirmations.logout.confirm": "Выйсці",
  "confirmations.logout.message": "Вы ўпэўненыя, што хочаце выйсці?",
  "confirmations.logout.title": "Выйсці?",
  "confirmations.missing_alt_text.confirm": "Дадаць альтэрнатыўны тэкст",
  "confirmations.missing_alt_text.message": "У Вашым допісе ёсць медыя без альтэрнатыўнага тэксту. Дадаванне апісання дапамагае зрабіць Ваш допіс даступным для большай колькасці людзей.",
  "confirmations.missing_alt_text.secondary": "Усё адно апублікаваць",
  "confirmations.missing_alt_text.title": "Дадаць альтэрнатыўны тэкст?",
  "confirmations.mute.confirm": "Ігнараваць",
  "confirmations.private_quote_notify.cancel": "Звяртацца да рэдагавання",
  "confirmations.private_quote_notify.confirm": "Апублікаваць допіс",
  "confirmations.private_quote_notify.do_not_show_again": "Больш не паказваць мне гэтае паведамленне",
  "confirmations.private_quote_notify.message": "Асоба, якую Вы цытуеце, і іншыя, хто быў узгаданы, атрымаюць апавяшчэнні і змогуць пабачыць Ваш допіс, нават калі яны не падпісаныя на Вас.",
  "confirmations.private_quote_notify.title": "Падзяліцца з падпісчыкамі і ўзгаданымі карыстальнікамі?",
  "confirmations.quiet_post_quote_info.dismiss": "Не нагадваць зноў",
  "confirmations.quiet_post_quote_info.got_it": "Зразумела",
  "confirmations.quiet_post_quote_info.message": "Калі будзеце цытаваць ціхі публічны допіс, Ваш допіс будзе схаваны ад трэндавых стужак.",
  "confirmations.quiet_post_quote_info.title": "Цытаванне ціхіх публічных допісаў",
  "confirmations.redraft.confirm": "Выдаліць і перапісаць",
  "confirmations.redraft.message": "Вы ўпэўненыя, што хочаце выдаліць допіс і перапісаць яго? Упадабанні і пашырэнні згубяцца, а адказы да арыгінальнага допісу асірацеюць.",
  "confirmations.redraft.title": "Выдаліць і перапісаць допіс?",
  "confirmations.remove_from_followers.confirm": "Выдаліць падпісчыка",
  "confirmations.remove_from_followers.message": "{name} больш не будзе падпісаны(-ая) на Вас. Упэўненыя, што хочаце працягнуць?",
  "confirmations.remove_from_followers.title": "Выдаліць падпісчыка?",
  "confirmations.revoke_collection_inclusion.confirm": "Прыбраць сябе",
  "confirmations.revoke_collection_inclusion.message": "Куратар не зможа вярнуць Вас у калекцыю на працягу 24 гадзін. Каб ён больш ніколі не мог дадаваць Вас у калекцыі, Вы можаце заблакіраваць яго.",
  "confirmations.revoke_collection_inclusion.title": "Прыбраць Вас з гэтай калекцыі?",
  "confirmations.revoke_quote.confirm": "Выдаліць допіс",
  "confirmations.revoke_quote.message": "Гэтае дзеянне немагчыма адмяніць.",
  "confirmations.revoke_quote.title": "Выдаліць допіс?",
  "confirmations.unblock.confirm": "Разблакіраваць",
  "confirmations.unblock.title": "Разблакіраваць {name}?",
  "confirmations.unfollow.confirm": "Адпісацца",
  "confirmations.unfollow.title": "Адпісацца ад {name}?",
  "confirmations.withdraw_request.confirm": "Адклікаць запыт",
  "confirmations.withdraw_request.title": "Адклікаць запыт на падпіску на {name}?",
  "content_warning.hide": "Схаваць допіс",
  "content_warning.show": "Усё адно паказаць",
  "content_warning.show_more": "Паказаць усё роўна",
  "content_warning.show_short": "Паказаць",
  "conversation.delete": "Выдаліць размову",
  "conversation.mark_as_read": "Адзначыць прачытаным",
  "conversation.open": "Прагледзець размову",
  "conversation.with": "З {names}",
  "copy_icon_button.copied": "Скапіявана ў буфер абмену",
  "copy_icon_button.copy_this_text": "Скапіяваць спасылку ў буфер абмену",
  "copypaste.copied": "Скапіравана",
  "copypaste.copy_to_clipboard": "Скапіяваць у буфер абмену",
  "custom_homepage.about": "Падрабязна",
  "custom_homepage.about_this_server": "Аб гэтым серверы",
  "custom_homepage.administered_by": "Адміністратар",
  "custom_homepage.contact": "Кантакты:",
  "custom_homepage.latest_activity": "Апошняя актыўнасць",
  "custom_homepage.these_are_the_latest_posts": "Гэта апошнія 40 допісаў з уліковых запісаў гэтага сервера.",
  "directory.federated": "З вядомага федэральнага сусвету",
  "directory.local": "Толькі з {domain}",
  "directory.new_arrivals": "Новыя карыстальнікі",
  "directory.recently_active": "Нядаўна актыўныя",
  "disabled_account_banner.account_settings": "Налады ўліковага запісу",
  "disabled_account_banner.text": "Ваш уліковы запіс {disabledAccount} часова адключаны.",
  "dismissable_banner.community_timeline": "Гэта самыя апошнія допісы ад людзей, уліковыя запісы якіх размяшчаюцца на {domain}.",
  "dismissable_banner.dismiss": "Адхіліць",
  "dismissable_banner.public_timeline": "Вось апошнія публічныя допісы ад карыстальнікаў федэральнага сусвету, на якіх падпісаныя карыстальнікі {domain}.",
  "domain_block_modal.block": "Заблакіраваць сервер",
  "domain_block_modal.block_account_instead": "Заблакіраваць @{name} замест гэтага",
  "domain_block_modal.they_can_interact_with_old_posts": "Людзі з гэтага сервера змогуць узаемадзейнічаць з вашымі старымі допісамі.",
  "domain_block_modal.they_cant_follow": "Ніхто з гэтага сервера не зможа падпісацца на вас.",
  "domain_block_modal.they_wont_know": "Карыстальнік не будзе ведаць пра блакіроўку.",
  "domain_block_modal.title": "Заблакіраваць дамен?",
  "domain_block_modal.you_will_lose_num_followers": "Вы страціце {followersCount, plural, one {{followersCountDisplay} падпісчыка} other {{followersCountDisplay} падпісчыкаў}} і {followingCount, plural, one {{followingCountDisplay} чалавека, на якога падпісаны} other {{followingCountDisplay} людзей, на якіх падпісаны}}.",
  "domain_block_modal.you_will_lose_relationships": "Вы страціце ўсіх падпісчыкаў і людзей на якіх падпісаны на гэтым серверы.",
  "domain_block_modal.you_wont_see_posts": "Вы не ўбачыце допісаў і апавяшчэнняў ад карыстальнікаў з гэтага сервера.",
  "dropdown.empty": "Выбраць варыянт",
  "email_subscriptions.email": "Эл. пошта",
  "email_subscriptions.form.action": "Падпісацца",
  "email_subscriptions.form.bottom": "Атрымлівайце допісы ў сваю паштовую скрыню без стварэння ўліковага запісу Mastodon. Пры жаданні зможаце адпісацца ў любы момант. Падрабязней у <a>Палітыцы прыватнасці</a>.",
  "email_subscriptions.form.title": "Зарэгістравацца на абнаўленні па электроннай пошце ад {name}",
  "email_subscriptions.submitted.lead": "Праверце сваю паштовую скрыню, каб знайсці там ліст і скончыць рэгістрацыю на абнаўленні па электроннай пошце.",
  "email_subscriptions.submitted.title": "Яшчэ адзін крок",
  "email_subscriptions.validation.email.blocked": "Заблакіраваны правайдар электроннай пошты",
  "email_subscriptions.validation.email.invalid": "Памылковы адрас электроннай пошты",
  "embed.instructions": "Убудуйце гэты допіс на свой сайт, скапіраваўшы прыведзены ніжэй код.",
  "embed.preview": "Вось як гэта будзе выглядаць:",
  "emoji_button.activity": "Актыўнасць",
  "emoji_button.clear": "Ачысціць",
  "emoji_button.custom": "Адвольныя",
  "emoji_button.flags": "Сцягі",
  "emoji_button.food": "Ежа і напоі",
  "emoji_button.label": "Уставіць эмодзі",
  "emoji_button.nature": "Прырода",
  "emoji_button.not_found": "Адпаведныя эмодзі не знойдзены",
  "emoji_button.objects": "Прадметы",
  "emoji_button.people": "Людзі",
  "emoji_button.recent": "Часта выкарыстоўваемыя",
  "emoji_button.search": "Пошук...",
  "emoji_button.search_results": "Вынікі пошуку",
  "emoji_button.symbols": "Сімвалы",
  "emoji_button.travel": "Падарожжы і месцы",
  "empty_column.account_featured.other": "{acct} пакуль нічога не адабраў(-ла) для паказу.",
  "empty_column.account_featured_self.no_collections_button": "Стварыць калекцыю",
  "empty_column.account_featured_self.no_collections_hide_tab": "Або схаваць гэтую ўкладку",
  "empty_column.account_featured_self.showcase_accounts": "Пакажыце свае ўлюбёныя ўліковыя запісы",
  "empty_column.account_featured_self.showcase_accounts_desc": "Калекцыі — спісы адабраных уліковых запісаў, якія дапамагаюць іншым знаходзіць нешта новае ў федэральным сусвеце.",
  "empty_column.account_featured_unknown.other": "Гэты ўліковы запіс пакуль нічога не адабраў для паказу.",
  "empty_column.account_hides_collections": "Гэты карыстальнік вырашыў схаваць гэтую інфармацыю",
  "empty_column.account_suspended": "Уліковы запіс прыпынены",
  "empty_column.account_timeline": "Тут няма допісаў!",
  "empty_column.account_unavailable": "Профіль недаступны",
  "empty_column.blocks": "Вы яшчэ нікога не заблакіравалі.",
  "empty_column.bookmarked_statuses": "У Вашых закладках яшчэ няма допісаў. Калі Вы дадасце закладку, яна з’явіцца тут.",
  "empty_column.collections": "{acct} пакуль не стварыў(-ла) аніводнай калекцыі.",
  "empty_column.collections.featured_in": "Вас пакуль не дадалі ў ніякія калекцыі.",
  "empty_column.collections.featured_in_undiscoverable": "Каб людзі маглі дадаваць Вас у калекцыі, Вам трэба даць ім дазвол знаходзіць Вас у <link>Налады > Прыватнасць і пошук</link>",
  "empty_column.collections_self": "Вы пакуль не стварылі ніводнай калекцыі.",
  "empty_column.community": "Мясцовая стужка пустая. Напішыце нешта публічнае, каб разварушыць справу!",
  "empty_column.direct": "Пакуль у Вас няма асабістых згадванняў. Калі Вы дашляце або атрымаеце штосьці, яно з’явіцца тут.",
  "empty_column.disabled_feed": "Гэта стужка была адключаная Вашымі адміністратарамі сервера.",
  "empty_column.domain_blocks": "Заблакіраваных даменаў пакуль няма.",
  "empty_column.explore_statuses": "Зараз не ў трэндзе. Праверце пазней",
  "empty_column.favourited_statuses": "Вы яшчэ не ўпадабалі ніводны допіс. Калі гэта адбудзецца, Вы ўбачыце яго тут.",
  "empty_column.favourites": "Ніхто яшчэ не ўпадабаў гэты допіс. Калі гэта адбудзецца, Вы ўбачыце гэтых людзей тут.",
  "empty_column.follow_requests": "У Вас яшчэ няма запытаў на падпіску. Калі Вы атрымаеце запыт, ён з’явіцца тут.",
  "empty_column.followed_tags": "Вы пакуль не падпісаны ні на адзін хэштэг. Калі падпішацеся, яны з’явяцца тут.",
  "empty_column.hashtag": "Па гэтаму хэштэгу пакуль што нічога няма.",
  "empty_column.home": "Галоўная стужка пустая! Падпішыцеся на іншых людзей, каб запоўніць яе. {suggestions}",
  "empty_column.list": "У гэтым спісе пакуль што нічога няма. Калі члены спіса апублікуюць новыя запісы, яны з'явяцца тут.",
  "empty_column.mutes": "Вы яшчэ нікога не ігнаруеце.",
  "empty_column.notification_requests": "Чысціня! Тут нічога няма. Калі Вы будзеце атрымліваць новыя апавяшчэнні, яны будуць з'яўляцца тут у адпаведнасці з Вашымі наладамі.",
  "empty_column.notifications": "У Вас няма ніякіх апавяшчэнняў. Калі іншыя людзі захочуць узаемадзейнічаць з Вамі, Вы ўбачыце гэта тут.",
  "empty_column.public": "Тут нічога няма! Апублікуйце што-небудзь, або падпішыцеся на карыстальнікаў з другіх сервераў",
  "empty_state.no_results": "Няма вынікаў",
  "error.no_hashtag_feed_access": "Далучайцеся або ўвайдзіце, каб праглядзець ці падпісацца на гэты хэштэг.",
  "error.unexpected_crash.explanation": "Гэта старонка не можа быць адлюстравана карэктна з-за памылкі ў нашым кодзе, або праблемы з сумяшчальнасцю браўзера.",
  "error.unexpected_crash.explanation_addons": "Гэтая старонка не можа быць адлюстравана карэктна. Верагодна, гэтая памылка выкліканая дадатковым кампанентам браўзера або інструментамі аўтаматычнага перакладу.",
  "error.unexpected_crash.next_steps": "Паспрабуйце абнавіць старонку. Калі гэта не дапаможа, Вы можаце паспрабаваць іншы браўзер, альбо выкарыстаць усталяваную праграму.",
  "error.unexpected_crash.next_steps_addons": "Паспрабуйце выключыць іх і абнавіць старонку. Калі гэта не дапамагае, Вы ўсё яшчэ можаце карыстацца Mastodon праз іншы браўзер ці асобную праграму.",
  "errors.unexpected_crash.copy_stacktrace": "Дадаць дыягнастычны стэк у буфер абмену",
  "errors.unexpected_crash.report_issue": "Паведаміць аб праблеме",
  "explore.suggested_follows": "Людзі",
  "explore.title": "Трэндавае",
  "explore.trending_links": "Навіны",
  "explore.trending_statuses": "Допісы",
  "explore.trending_tags": "Хэштэгі",
  "featured_carousel.current": "<sr>Допіс</sr> {current, number} з {max, number}",
  "featured_carousel.header": "{count, plural,one {Замацаваны допіс} other {Замацаваныя допісы}}",
  "featured_carousel.slide": "Допіс {current, number} з {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Апошнім часам Вы рабілі допісы пра {items}. Дадаць гэта ў выбраныя хэштэгі?",
  "featured_tags.suggestions.add": "Дадаць",
  "featured_tags.suggestions.added": "Кіруйце сваімі выбранымі хэштэгамі ў любы час праз <link>Рэдагаваць профіль > Выбраныя хэштэгі</link>.",
  "featured_tags.suggestions.dismiss": "Не, дзякуй",
  "filter_modal.added.context_mismatch_explanation": "Гэтая катэгорыя фільтра не прымяняецца да кантэксту, у якім Вы адкрылі гэты допіс. Калі Вы хочаце, каб паведамленне таксама было адфільтраванае ў гэтым кантэксце, Вам трэба будзе адрэдагаваць фільтр.",
  "filter_modal.added.context_mismatch_title": "Неадпаведны кантэкст!",
  "filter_modal.added.expired_explanation": "Тэрмін дзеяння гэтай катэгорыі фільтраў скончыўся, вам трэба будзе змяніць дату заканчэння тэрміну дзеяння, каб яна прымянялася",
  "filter_modal.added.expired_title": "Пратэрмінаваны фільтр!",
  "filter_modal.added.review_and_configure": "Для прагляду і наступнай канфігурацыі фільтра катэгорый, перайдзіце на {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Налады фільтра",
  "filter_modal.added.settings_link": "старонка наладаў",
  "filter_modal.added.short_explanation": "Гэты допіс быў дададзены ў катэгорыю з наступным фільтрам: {title}.",
  "filter_modal.added.title": "Фільтр дабаўлены!",
  "filter_modal.select_filter.context_mismatch": "Не мае дачынення да кантэксту ",
  "filter_modal.select_filter.expired": "пратэрмінавана",
  "filter_modal.select_filter.prompt_new": "Новая катэгорыя: {name}",
  "filter_modal.select_filter.search": "Шукаць альбо стварыць",
  "filter_modal.select_filter.subtitle": "Скарыстайцеся існуючай катэгорыяй або стварыце новую",
  "filter_modal.select_filter.title": "Фільтраваць гэты допіс",
  "filter_modal.title.status": "Фільтраваць допіс",
  "filter_warning.matches_filter": "Адпавядае фільтру \"<span>{title}</span>\"",
  "filtered_notifications_banner.pending_requests": "Ад {count, plural, =0 {# людзей якіх} one {# чалавека якіх} few {# чалавек якіх} many {# людзей якіх} other {# чалавека якіх}} Вы магчыма ведаеце",
  "filtered_notifications_banner.title": "Адфільтраваныя апавяшчэнні",
  "firehose.all": "Усе",
  "firehose.local": "Гэты сервер",
  "firehose.remote": "Іншыя серверы",
  "follow_request.authorize": "Аўтарызацыя",
  "follow_request.reject": "Адхіліць",
  "follow_requests.unlocked_explanation": "Ваш уліковы запіс не схаваны, аднак прадстаўнікі {domain} палічылі, што Вы можаце захацець праглядзець запыты на падпіску з гэтых уліковых запісаў уручную.",
  "follow_suggestions.curated_suggestion": "Выбар адміністрацыі",
  "follow_suggestions.dismiss": "Не паказваць зноў",
  "follow_suggestions.featured_longer": "Адабраныя камандай {domain} уручную",
  "follow_suggestions.friends_of_friends_longer": "Папулярнае сярод людзей, на якіх Вы падпісаныя",
  "follow_suggestions.hints.featured": "Гэты профіль быў выбраны ўручную камандай {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Гэты профіль папулярны сярод людзей, на якіх Вы падпісаліся.",
  "follow_suggestions.hints.most_followed": "Гэты профіль - адзін з профіляў з самай вялікай колькасцю падпісак на {domain}.",
  "follow_suggestions.hints.most_interactions": "У апошні час гэты профіль прыцягвае шмат увагі на {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Гэты профіль падобны на профілі, на якія Вы нядаўна падпісаліся.",
  "follow_suggestions.personalized_suggestion": "Персаналізаваная прапанова",
  "follow_suggestions.popular_suggestion": "Папулярная прапанова",
  "follow_suggestions.popular_suggestion_longer": "Папулярнае на {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Падобныя профілі, за якімі Вы нядаўна сачылі",
  "follow_suggestions.view_all": "Праглядзець усё",
  "follow_suggestions.who_to_follow": "На каго падпісацца",
  "followed_tags": "Падпіскі на хэштэгі",
  "followers.hide_other_followers": "Гэты карыстальнік вырашыў не паказваць сваіх іншых падпісчыкаў",
  "followers.title": "Падпісаны(-ая) на {name}",
  "following.hide_other_following": "Гэты карыстальнік вырашыў не паказваць свае іншыя падпіскі",
  "following.title": "Падпісаны(-ая) {name}",
  "footer.about": "Пра нас",
  "footer.about_mastodon": "Пра Mastodon",
  "footer.about_server": "Пра {domain}",
  "footer.about_this_server": "Пра сервер",
  "footer.directory": "Дырэкторыя профіляў",
  "footer.get_app": "Спампаваць праграму",
  "footer.keyboard_shortcuts": "Спалучэнні клавіш",
  "footer.privacy_policy": "Палітыка прыватнасці",
  "footer.source_code": "Прагледзець зыходны код",
  "footer.status": "Статус",
  "footer.terms_of_service": "Умовы выкарыстання",
  "form_error.blank": "Поле не можа быць пустым.",
  "form_field.optional": "(неабавязкова)",
  "getting_started.heading": "Пачатак працы",
  "hashtag.admin_moderation": "Адкрыць інтэрфейс мадэратара для #{name}",
  "hashtag.browse": "Праглядзець допісы ў #{hashtag}",
  "hashtag.browse_from_account": "Праглядзець допісы ад @{name} у #{hashtag}",
  "hashtag.column_header.tag_mode.all": "і {additional}",
  "hashtag.column_header.tag_mode.any": "або {additional}",
  "hashtag.column_header.tag_mode.none": "без {additional}",
  "hashtag.column_settings.select.no_options_message": "Няма рэкамендацый",
  "hashtag.column_settings.select.placeholder": "Увядзіце хэштэгі…",
  "hashtag.column_settings.tag_mode.all": "Усе",
  "hashtag.column_settings.tag_mode.any": "Любы",
  "hashtag.column_settings.tag_mode.none": "Нічога з пералічанага",
  "hashtag.column_settings.tag_toggle": "Уключыць дадатковыя тэгі для гэтай калонкі",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} удзельнік} few {{counter} удзельніка} many {{counter} удзельнікаў} other {{counter} удзельніка}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} допіс} few {{counter} допісы} many {{counter} допісаў} other {{counter} допісу}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} допіс} few {{counter} допісы} many {{counter} допісаў} other {{counter} допісу}} за сёння",
  "hashtag.feature": "Паказваць у профілі",
  "hashtag.follow": "Падпісацца на хэштэг",
  "hashtag.mute": "Ігнараваць #{hashtag}",
  "hashtag.unfeature": "Не паказваць у профілі",
  "hashtag.unfollow": "Адпісацца ад хэштэга",
  "hashtags.and_other": "…і яшчэ {count, plural,  other {#}}",
  "hints.profiles.followers_may_be_missing": "Падпісчыкі гэтага профілю могуць адсутнічаць.",
  "hints.profiles.follows_may_be_missing": "Падпіскі гэтага профілю могуць адсутнічаць.",
  "hints.profiles.posts_may_be_missing": "Некаторыя допісы гэтага профілю могуць адсутнічаць.",
  "hints.profiles.see_more_followers": "Глядзець больш падпісаных на {domain}",
  "hints.profiles.see_more_follows": "Глядзець больш падпісак на {domain}",
  "hints.profiles.see_more_posts": "Глядзець больш допісаў на {domain}",
  "home.column_settings.show_quotes": "Паказаць цытаванні",
  "home.column_settings.show_reblogs": "Паказваць пашырэнні",
  "home.column_settings.show_replies": "Паказваць адказы",
  "home.hide_announcements": "Схаваць аб'явы",
  "home.pending_critical_update.body": "Абнавіце свой сервер Mastodon як мага хутчэй!",
  "home.pending_critical_update.link": "Прагледзець абнаўленні",
  "home.pending_critical_update.title": "Даступна крытычнае абнаўленне бяспекі!",
  "home.show_announcements": "Паказаць аб'явы",
  "ignore_notifications_modal.bots_title": "Ігнараваць апавяшчэнні ад ботаў?",
  "ignore_notifications_modal.disclaimer": "Mastodon не можа паведамляць карыстальнікам, што Вы праігнаравалі апавяшчэнні ад іх. Ігнараванне апавяшчэнняў не спыніць адпраўку саміх паведамленняў.",
  "ignore_notifications_modal.filter_instead": "Замест гэтага адфільтраваць",
  "ignore_notifications_modal.filter_to_act_users": "Вы па-ранейшаму зможаце прымаць, адхіляць ці скардзіцца на карыстальнікаў",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Выкарыстанне фільтраў дапамагае пазбягаць патэнцыйнай блытаніны",
  "ignore_notifications_modal.filter_to_review_separately": "Вы можаце прагледзець адфільтраваныя апавяшчэнні асобна",
  "ignore_notifications_modal.ignore": "Ігнараваць апавяшчэнні",
  "ignore_notifications_modal.limited_accounts_title": "Ігнараваць апавяшчэнні ад уліковых запісаў пад мадэрацыяй?",
  "ignore_notifications_modal.new_accounts_title": "Ігнараваць апавяшчэнні ад новых уліковых запісаў?",
  "ignore_notifications_modal.not_followers_title": "Ігнараваць апавяшчэнні ад людзей, якія не падпісаныя на вас?",
  "ignore_notifications_modal.not_following_title": "Ігнараваць апавяшчэнні ад людзей, на якіх Вы не падпісаныя?",
  "ignore_notifications_modal.private_mentions_title": "Ігнараваць апавяшчэнні пра непажаданыя прыватныя згадванні?",
  "info_button.label": "Даведка",
  "info_button.what_is_alt_text": "<h1>Што такое альтэрнатыўны тэкст?</h1> <p>Альтэрнатыўны тэкст апісвае відарыс людзям з парушэннем зроку, павольным злучэннем або тым, каму патрэбны дадатковы кантэкст.</p> <p>Вы можаце зрабіць відарыс больш дасяжным і зразумелым для ўсіх, напісаўшы зразумелы, сціслы і аб'ектыўны альтэрнатыўны тэкст.</p> <ul><li>Ахоплівайце важныя элементы</li> <li>Тлумачце тэкст на відарысе</li> <li>Карыстайцеся звычайнымі сказамі</li> <li>Пазбягайце залішняй інфармацыі</li> <li>Засяроджвайцеся на тэндэнцыях і ключавых высновах у цяжкіх для разумення візуальных матэрыялах (напрыклад, дыяграмах або картах)</li></ul>",
  "interaction_modal.action": "Каб узаемадзейнічаць з допісам {name}, Вам трэба ўвайсці ў свой уліковы запіс на любым серверы Mastodon, якім Вы карыстаецеся.",
  "interaction_modal.action_follow": "Каб падпісацца на {name}, Вам трэба ўвайсці ў свой уліковы запіс на любым серверы Mastodon, якім Вы карыстаецеся.",
  "interaction_modal.go": "Перайсці",
  "interaction_modal.no_account_yet": "Не маеце ўліковага запісу?",
  "interaction_modal.on_another_server": "На іншым серверы",
  "interaction_modal.on_this_server": "На гэтым серверы",
  "interaction_modal.title": "Увайдзіце, каб працягнуць",
  "interaction_modal.username_prompt": "Напр., {example}",
  "intervals.full.days": "{number, plural, one {# дзень} few {# дні} many {# дзён} other {# дня}}",
  "intervals.full.hours": "{number, plural, one {# гадзіна} few {# гадзіны} many {# гадзін} other {# гадзіны}}",
  "intervals.full.minutes": "{number, plural, one {# хвіліна} few {# хвіліны} many {# хвілін} other {# хвіліны}}",
  "keyboard_shortcuts.back": "Вярнуцца назад",
  "keyboard_shortcuts.blocked": "Адкрыць спіс заблакаваных карыстальнікаў",
  "keyboard_shortcuts.boost": "Пашырыць допіс",
  "keyboard_shortcuts.column": "Сфакусіравацца на калонцы",
  "keyboard_shortcuts.compose": "Сфакусіравацца на тэкставай вобласці",
  "keyboard_shortcuts.description": "Апісанне",
  "keyboard_shortcuts.direct": "Адкрыць слупок прыватных згадванняў",
  "keyboard_shortcuts.down": "Перамясціцца ўніз па спісе",
  "keyboard_shortcuts.enter": "Адкрыць допіс",
  "keyboard_shortcuts.explore": "Адкрыць трэндавую стужку",
  "keyboard_shortcuts.favourite": "Упадабаць допіс",
  "keyboard_shortcuts.favourites": "Адкрыць спіс упадабанага",
  "keyboard_shortcuts.federated": "Адкрыць інтэграваную стужку",
  "keyboard_shortcuts.heading": "Спалучэнні клавіш",
  "keyboard_shortcuts.home": "Адкрыць хатнюю храналагічную стужку",
  "keyboard_shortcuts.hotkey": "Спалучэнне клавіш",
  "keyboard_shortcuts.keys.alt": "Alt",
  "keyboard_shortcuts.keys.backspace": "Backspace",
  "keyboard_shortcuts.keys.enter": "Enter",
  "keyboard_shortcuts.keys.esc": "Esc",
  "keyboard_shortcuts.keys.page_down": "Page Down",
  "keyboard_shortcuts.keys.page_up": "Page Up",
  "keyboard_shortcuts.legend": "Паказаць легенду",
  "keyboard_shortcuts.load_more": "Навесці на кнопку \"Загрузіць болей\"",
  "keyboard_shortcuts.local": "Адкрыць хатнюю храналагічную стужку",
  "keyboard_shortcuts.mention": "Згадаць аўтара",
  "keyboard_shortcuts.muted": "Адкрыць спіс ігнараваных карыстальнікаў",
  "keyboard_shortcuts.my_profile": "Адкрыць ваш профіль",
  "keyboard_shortcuts.notifications": "Адкрыць слупок апавяшчэнняў",
  "keyboard_shortcuts.open_media": "Адкрыць медыя",
  "keyboard_shortcuts.pinned": "Адкрыць спіс замацаваных допісаў",
  "keyboard_shortcuts.profile": "Адкрыць профіль аўтара",
  "keyboard_shortcuts.quote": "Цытаваць допіс",
  "keyboard_shortcuts.reply": "Адказаць на допіс",
  "keyboard_shortcuts.requests": "Адкрыць спіс запытаў на падпіску",
  "keyboard_shortcuts.search": "Сфакусіраваць пошукавы радок",
  "keyboard_shortcuts.spoilers": "Паказаць/схаваць поле \"папярэджанне пра змест\"",
  "keyboard_shortcuts.start": "Адкрыць стартавую калонку",
  "keyboard_shortcuts.toggle_hidden": "Паказаць/схаваць тэкст за папярэджаннем пра кантэнт",
  "keyboard_shortcuts.toggle_sensitivity": "Паказаць/схаваць медыя",
  "keyboard_shortcuts.toot": "Стварыць новы допіс",
  "keyboard_shortcuts.top": "Перайсці да вяршыні спіса",
  "keyboard_shortcuts.translate": "Перакласці допіс",
  "keyboard_shortcuts.unfocus": "Расфакусіраваць тэкставую вобласць/пошукавы радок",
  "keyboard_shortcuts.up": "Перамясціцца ўверх па спісе",
  "learn_more_link.got_it": "Зразумеў(-ла)",
  "learn_more_link.learn_more": "Падрабязней",
  "lightbox.close": "Закрыць",
  "lightbox.next": "Далей",
  "lightbox.previous": "Назад",
  "lightbox.zoom_in": "Маштабаваць да фактычнага памеру",
  "lightbox.zoom_out": "Дапасаваць усё змесціва пад памеры экрана",
  "limited_account_hint.action": "Усе роўна паказваць профіль",
  "limited_account_hint.title": "Гэты профіль або сервер быў схаваны мадэратарамі {domain}.",
  "link_preview.author": "Ад {name}",
  "link_preview.more_from_author": "Больш ад {name}",
  "link_preview.shares": "{count, plural, one {{counter} допіс} few {{counter} допісы} many {{counter} допісаў} other {{counter} допісу}}",
  "lists.add_member": "Дадаць",
  "lists.add_to_list": "Дадаць у спіс",
  "lists.add_to_lists": "Дадаць {name} у спісы",
  "lists.create": "Стварыць",
  "lists.create_a_list_to_organize": "Стварыце новы спіс, каб арганізаваць сваю Галоўную старонку",
  "lists.create_list": "Стварыць спіс",
  "lists.delete": "Выдаліць спіс",
  "lists.done": "Гатова",
  "lists.edit": "Рэдагаваць спіс",
  "lists.exclusive": "Схаваць карыстальнікаў на Галоўнай старонцы",
  "lists.exclusive_hint": "Калі ў гэтым спісе нехта ёсць, схавайце яго на сваёй Галоўнай старонцы, каб не бачыць яго допісы двойчы.",
  "lists.find_users_to_add": "Знайсці карыстальнікаў, каб дадаць",
  "lists.list_members_count": "{count, plural,one {# карыстальнік}other {# карыстальнікі}}",
  "lists.list_name": "Назва спіса",
  "lists.new_list_name": "Назва новага спіса",
  "lists.no_lists_yet": "Пакуль няма спісаў.",
  "lists.no_members_yet": "Пакуль няма ўдзельнікаў.",
  "lists.no_results_found": "Нічога не знойдзена.",
  "lists.remove_member": "Выдаліць",
  "lists.replies_policy.followed": "Любы карыстальнік, на якога Вы падпісаліся",
  "lists.replies_policy.list": "Удзельнікі гэтага спісу",
  "lists.replies_policy.none": "Нікога",
  "lists.save": "Захаваць",
  "lists.search": "Пошук",
  "lists.show_replies_to": "Уключыць адказы ад карыстальнікаў са спіса",
  "load_pending": "{count, plural, one {# новы элемент} few {# новыя элементы} many {# новых элементаў} other {# новых элементаў}}",
  "loading_indicator.label": "Ідзе загрузка…",
  "media_gallery.hide": "Схаваць",
  "moved_to_account_banner.text": "Ваш уліковы запіс {disabledAccount} зараз адключаны, таму што Вы перайшлі на {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Схаваць з апавяшчэнняў",
  "mute_modal.hide_options": "Схаваць опцыі",
  "mute_modal.indefinite": "Пакуль я не прыбяру ігнараванне",
  "mute_modal.show_options": "Паказаць опцыі",
  "mute_modal.they_can_mention_and_follow": "Карыстальнік зможа згадваць Вас і падпісацца на Вас, але Вы гэтага не ўбачыце.",
  "mute_modal.they_wont_know": "Карыстальнік не будзе ведаць пра ігнараванне.",
  "mute_modal.title": "Ігнараваць карыстальніка?",
  "mute_modal.you_wont_see_mentions": "Вы не ўбачыце паведамленняў са згадваннем карыстальніка.",
  "mute_modal.you_wont_see_posts": "Карыстальнік па-ранейшаму будзе бачыць Вашыя допісы, але Вы не будзеце бачыць ягоныя.",
  "navigation_bar.about": "Пра нас",
  "navigation_bar.account_settings": "Пароль і бяспека",
  "navigation_bar.administration": "Адміністрацыя",
  "navigation_bar.advanced_interface": "Адкрыць у пашыраным вэб-інтэрфейсе",
  "navigation_bar.automated_deletion": "Аўтаматычнае выдаленне допісаў",
  "navigation_bar.blocks": "Заблакіраваныя карыстальнікі",
  "navigation_bar.bookmarks": "Закладкі",
  "navigation_bar.collections": "Калекцыі",
  "navigation_bar.direct": "Прыватныя згадванні",
  "navigation_bar.domain_blocks": "Заблакіраваныя дамены",
  "navigation_bar.favourites": "Упадабанае",
  "navigation_bar.filters": "Ігнараваныя словы",
  "navigation_bar.follow_requests": "Запыты на падпіску",
  "navigation_bar.followed_tags": "Падпіскі",
  "navigation_bar.follows_and_followers": "Падпіскі і падпісчыкі",
  "navigation_bar.import_export": "Імпарт і экспарт",
  "navigation_bar.lists": "Спісы",
  "navigation_bar.live_feed_local": "Жывая стужка (лакальная)",
  "navigation_bar.live_feed_public": "Жывая стужка (публічная)",
  "navigation_bar.logout": "Выйсці",
  "navigation_bar.main": "Галоўная",
  "navigation_bar.moderation": "Мадэрацыя",
  "navigation_bar.more": "Больш",
  "navigation_bar.mutes": "Ігнараваныя карыстальнікі",
  "navigation_bar.opened_in_classic_interface": "Допісы, уліковыя запісы і іншыя спецыфічныя старонкі па змоўчанні адчыняюцца ў класічным вэб-інтэрфейсе.",
  "navigation_bar.preferences": "Налады",
  "navigation_bar.privacy_and_reach": "Прыватнасць і пошук",
  "navigation_bar.search": "Пошук",
  "navigation_bar.search_trends": "Пошук / Трэндавае",
  "navigation_panel.collapse_followed_tags": "Згарнуць меню падпісак на хэштэгі",
  "navigation_panel.collapse_lists": "Згарнуць меню спісаў",
  "navigation_panel.expand_followed_tags": "Разгарнуць меню падпісак на хэштэгі",
  "navigation_panel.expand_lists": "Разгарнуць меню спіса",
  "not_signed_in_indicator.not_signed_in": "Вам трэба ўвайсці каб атрымаць доступ да гэтага рэсурсу.",
  "notification.added_to_collection": "{name} дадаў(-ла) Вас у калекцыю",
  "notification.admin.report": "{name} паскардзіўся(-лась) на {target}",
  "notification.admin.report_account": "{name} паскардзіўся(-лась) на {count, plural, one {# допіс} many {# допісаў} other {# допіса}} ад {target} з прычыны {category}",
  "notification.admin.report_account_other": "{name} паскардзіўся(-лась) на {count, plural, one {# допіс} many {# допісаў} other {# допіса}} ад {target}",
  "notification.admin.report_statuses": "{name} паскардзіўся(-лась) на {target} з прычыны {category}",
  "notification.admin.report_statuses_other": "{name} паскардзіўся(-лась) на {target}",
  "notification.admin.sign_up": "{name} зарэгістраваўся(-лась)",
  "notification.admin.sign_up.name_and_others": "{name} і {count, plural, one {# іншы(-ая)} other {# іншых}} зарэгістраваліся",
  "notification.annual_report.message": "Вас чакае Ваш #Wrapstodon нумар {year}! Падзяліцеся сваімі галоўнымі падзеямі і запамінальнымі момантамі ў Mastodon!",
  "notification.annual_report.view": "Перайсці да #Wrapstodon",
  "notification.collection_update": "{name} рэдагаваў(-ла) калекцыю, у якой ёсць Вы",
  "notification.favourite": "{name} упадабаў(-ла) Ваш допіс",
  "notification.favourite.name_and_others_with_link": "{name} і <a>{count, plural, one {# іншы(-ая)} other {# іншыя}}</a> ўпадабалі Ваш допіс",
  "notification.favourite_pm": "{name} упадабаў(-ла) Вашае прыватнае згадванне",
  "notification.favourite_pm.name_and_others_with_link": "{name} і <a>{count, plural, one {# іншы(-ая)} few {# іншыя} many {# іншых} other {# іншых}}</a> ўпадабалі ваша асабістае згадванне",
  "notification.follow": "{name} падпісаўся(-лась) на Вас",
  "notification.follow.name_and_others": "{name} і <a>{count, plural, one {# іншы(-ая)} other {# іншыя}}</a> падпісаліся на Вас",
  "notification.follow_request": "{name} адправіў(-ла) запыт на падпіску",
  "notification.follow_request.name_and_others": "{name} і {count, plural, one {# іншы} many {# іншых} other {# іншых}} запыталіся падпісацца на вас",
  "notification.label.mention": "Згадванне",
  "notification.label.private_mention": "Асабістае згадванне",
  "notification.label.private_reply": "Асабісты адказ",
  "notification.label.quote": "{name} цытаваў(-ла) Ваш допіс",
  "notification.label.reply": "Адказ",
  "notification.mention": "Згадванне",
  "notification.mentioned_you": "{name} згадаў(-ла) Вас",
  "notification.moderation-warning.learn_more": "Даведацца больш",
  "notification.moderation_warning": "Вы атрымалі папярэджанне ад мадэратараў",
  "notification.moderation_warning.action_delete_statuses": "Некаторыя Вашыя допісы былі выдаленыя.",
  "notification.moderation_warning.action_disable": "Ваш уліковы запіс быў адключаны.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Некаторыя з вашых допісаў былі пазначаныя як адчувальныя.",
  "notification.moderation_warning.action_none": "Ваш уліковы запіс атрымаў папярэджанне ад мадэратараў.",
  "notification.moderation_warning.action_sensitive": "З гэтага моманту вашыя допісы будуць пазначаныя як адчувальныя.",
  "notification.moderation_warning.action_silence": "Ваш уліковы запіс быў абмежаваны.",
  "notification.moderation_warning.action_suspend": "Ваш уліковы запіс быў заблакіраваны.",
  "notification.own_poll": "Ваша апытанне скончылася",
  "notification.poll": "Апытанне, дзе Вы прынялі ўдзел, скончылася",
  "notification.quoted_update": "{name} адрэдагаваў(-ла) допіс, які Вы цытавалі",
  "notification.reblog": "{name} пашырыў(-ла) Ваш допіс",
  "notification.reblog.name_and_others_with_link": "{name} і <a>{count, plural, one {# іншы(-ая)} many {# іншых} other {# іншых}}</a> пашырылі Ваш допіс",
  "notification.relationships_severance_event": "Страціў сувязь з {name}",
  "notification.relationships_severance_event.account_suspension": "Адміністратар з {from} прыпыніў працу ўліковага запісу {target}, што азначае, што Вы больш не можаце атрымліваць ад іх абнаўленні ці ўзаемадзейнічаць з імі.",
  "notification.relationships_severance_event.domain_block": "Адміністратар з {from} заблакіраваў {target}, у тым ліку {followersCount} вашых падпісчыка(-аў) і {followingCount, plural, one {# уліковы запіс} few {# уліковыя запісы} many {# уліковых запісаў} other {# уліковых запісаў}}.",
  "notification.relationships_severance_event.learn_more": "Даведацца больш",
  "notification.relationships_severance_event.user_domain_block": "Вы заблакіравалі {target} выдаліўшы {followersCount} сваіх падпісчыкаў і {followingCount, plural, one {# уліковы запіс} few {# уліковыя запісы} many {# уліковых запісаў} other {# уліковых запісаў}}, за якімі Вы сочыце.",
  "notification.status": "Новы допіс ад {name}",
  "notification.update": "Допіс {name} адрэдагаваны",
  "notification_requests.accept": "Прыняць",
  "notification_requests.accept_multiple": "{count, plural,one {Прыняць # запыт…} other {Прыняць # запытаў…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural,one {Прыняць запыт} other {Прыняць запыты}}",
  "notification_requests.confirm_accept_multiple.message": "Вы збіраецеся прыняць {count, plural, one {адзін запыт на апавяшчэнне} other {# запытаў на апавяшчэнне}}. Упэўненыя, што хочаце працягнуць?",
  "notification_requests.confirm_accept_multiple.title": "Прыняць запыты на апавяшчэнні?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural,one {Адмовіцца ад запыту} other {Адмовіцца ад запытаў}}",
  "notification_requests.confirm_dismiss_multiple.message": "Вы збіраецеся адмовіцца ад {count, plural, one {аднаго запыту на апавяшчэнне} other {# запытаў на апавяшчэнне}}. Вы не зможаце зноў лёгка атрымаць доступ да {count, plural, one {яго} other {іх}}. Упэўненыя, што хочаце працягнуць?",
  "notification_requests.confirm_dismiss_multiple.title": "Адхіліць запыты на апавяшчэнні?",
  "notification_requests.dismiss": "Адхіліць",
  "notification_requests.dismiss_multiple": "{count, plural,one {Адмовіцца ад запыту…} other {Адмовіцца ад запытаў…}}",
  "notification_requests.edit_selection": "Рэдагаваць",
  "notification_requests.exit_selection": "Гатова",
  "notification_requests.explainer_for_limited_account": "Апавяшчэнне з гэтага ўліковага запісу было адфільтраванае, бо гэты ўліковы запіс абмежаваў мадэратар.",
  "notification_requests.explainer_for_limited_remote_account": "Апавяшчэнні з гэтага ўліковага запісу былі адфільтраваныя, бо гэты ўліковы запіс абмежаваў мадэратар.",
  "notification_requests.maximize": "Разгарнуць",
  "notification_requests.minimize_banner": "Згарнуць банер адфільтраваных апавяшчэнняў",
  "notification_requests.notifications_from": "Апавяшчэнні ад {name}",
  "notification_requests.title": "Адфільтраваныя апавяшчэнні",
  "notification_requests.view": "Прагляд апавяшчэнняў",
  "notifications.clear": "Ачысціць апавяшчэнні",
  "notifications.clear_confirmation": "Вы ўпэўнены, што хочаце назаўсёды сцерці ўсе свае паведамленні?",
  "notifications.clear_title": "Ачысціць апавяшчэнні?",
  "notifications.column_settings.admin.report": "Новыя скаргі:",
  "notifications.column_settings.admin.sign_up": "Новыя рэгістрацыі:",
  "notifications.column_settings.alert": "Апавяшчэнні на працоўным стале",
  "notifications.column_settings.collections": "Калекцыі:",
  "notifications.column_settings.favourite": "Упадабанае:",
  "notifications.column_settings.filter_bar.advanced": "Паказаць усе катэгорыі",
  "notifications.column_settings.filter_bar.category": "Панэль хуткай фільтрацыі",
  "notifications.column_settings.follow": "Новыя падпісчыкі:",
  "notifications.column_settings.follow_request": "Новыя запыты на падпіску:",
  "notifications.column_settings.group": "Аб’яднаць апавяшчэнні ад падпісчыкаў",
  "notifications.column_settings.mention": "Згадванні:",
  "notifications.column_settings.poll": "Вынікі апытання:",
  "notifications.column_settings.push": "Push-апавяшчэнні",
  "notifications.column_settings.quote": "Цытаваныя допісы:",
  "notifications.column_settings.reblog": "Пашырэнні:",
  "notifications.column_settings.show": "Паказваць у слупку",
  "notifications.column_settings.sound": "Прайграваць гук",
  "notifications.column_settings.status": "Новыя допісы:",
  "notifications.column_settings.unread_notifications.category": "Непрачытаныя апавяшчэнні",
  "notifications.column_settings.unread_notifications.highlight": "Вылучыць непрачытаныя апавяшчэнні",
  "notifications.column_settings.update": "Праўкі:",
  "notifications.filter.all": "Усе",
  "notifications.filter.boosts": "Пашырэнні",
  "notifications.filter.collections": "Калекцыі",
  "notifications.filter.favourites": "Упадабанае",
  "notifications.filter.follows": "Падпісаны на",
  "notifications.filter.mentions": "Згадванні",
  "notifications.filter.polls": "Вынікі апытання",
  "notifications.filter.statuses": "Навіны ад людзей, на якіх Вы падпісаныя",
  "notifications.grant_permission": "Дазволіць.",
  "notifications.group": "{count} Апавяшчэнняў",
  "notifications.mark_as_read": "Пазначыць усе апавяшчэнні як прачытаныя",
  "notifications.permission_denied": "Апавяшчэнні на працоўным стале недаступныя з-за папярэдне адхіленага запыта праў браўзера",
  "notifications.permission_denied_alert": "З-за таго, што запыт браўзера быў раней адхілены, немагчыма ўключыць апавяшчэнні на працоўным стале",
  "notifications.permission_required": "Апавяшчэнні на працоўным стале недаступныя, з-за таго што неабходны дазвол не быў дадзены.",
  "notifications.policy.accept": "Прыняць",
  "notifications.policy.accept_hint": "Паказваць у апавяшчэннях",
  "notifications.policy.drop": "Iгнараваць",
  "notifications.policy.drop_hint": "Адправіць у бездань, адкуль больш ніколі не ўбачыце",
  "notifications.policy.filter": "Фільтраваць",
  "notifications.policy.filter_bots_hint": "Уліковыя запісы, пазначаныя як аўтаматычныя",
  "notifications.policy.filter_bots_title": "Боты",
  "notifications.policy.filter_hint": "Адправіць у скрыню адфільтраваных апавяшчэнняў",
  "notifications.policy.filter_limited_accounts_hint": "Абмежавана мадэратарамі сервера",
  "notifications.policy.filter_limited_accounts_title": "Уліковыя запісы пад мадэрацыяй",
  "notifications.policy.filter_new_accounts.hint": "Створаныя на працягу {days, plural, one {апошняга # дня} few {апошніх # дзён} many {апошніх # дзён} other {апошняй # дня}}",
  "notifications.policy.filter_new_accounts_title": "Новыя ўліковыя запісы",
  "notifications.policy.filter_not_followers_hint": "Уключаючы людзей, якія падпісаны на вас менш, чым {days, plural, one {# дзень} few {# дні} many {# дзён} other {# дня}}",
  "notifications.policy.filter_not_followers_title": "Людзі, якія не падпісаны на вас",
  "notifications.policy.filter_not_following_hint": "Пакуль вы не пацвердзіце іх уручную",
  "notifications.policy.filter_not_following_title": "Людзі, на якіх Вы не падпісаныя",
  "notifications.policy.filter_private_mentions_hint": "Фільтруецца, за выключэннем адказу на Вашае згадванне ці калі Вы падпісаныя на адпраўніка",
  "notifications.policy.filter_private_mentions_title": "Непажаданыя прыватныя згадванні",
  "notifications.policy.title": "Наладзіць апавяшчэнні ад…",
  "notifications_permission_banner.enable": "Уключыць апавяшчэнні на працоўным стале",
  "notifications_permission_banner.how_to_control": "Каб атрымліваць апавяшчэнні, калі Mastodon не адкрыты, уключыце апавяшчэнні працоўнага стала. Вы зможаце дакладна кантраляваць, якія падзеі будуць ствараць апавяшчэнні з дапамогай {icon} кнопкі, як толькі яны будуць уключаны.",
  "notifications_permission_banner.title": "Не прапусціце нічога",
  "onboarding.follows.back": "Назад",
  "onboarding.follows.empty": "На жаль, зараз немагчыма паказаць вынікі. Вы можаце паспрабаваць выкарыстоўваць пошук і праглядзець старонку агляду, каб знайсці людзей, на якіх можна падпісацца, або паўтарыць спробу пазней.",
  "onboarding.follows.next": "Далей: Наладзьце свой профіль",
  "onboarding.follows.search": "Пошук",
  "onboarding.follows.title": "Падпішыцеся на некага, каб пачаць",
  "onboarding.profile.discoverable": "Зрабіць мой профіль бачным",
  "onboarding.profile.discoverable_hint": "Калі Вы звяртаецеся да адкрытасці на Mastodon, Вашы допісы могуць з'яўляцца ў выніках пошуку і трэндах, а Ваш профіль можа быць прапанаваны людзям з такімі ж інтарэсамі.",
  "onboarding.profile.display_name": "Бачнае імя",
  "onboarding.profile.display_name_hint": "Ваша поўнае імя або ваш псеўданім…",
  "onboarding.profile.finish": "Гатова",
  "onboarding.profile.note": "Біяграфія",
  "onboarding.profile.note_hint": "Вы можаце @згадваць іншых людзей або выкарыстоўваць #хэштэгі…",
  "onboarding.profile.title": "Налады профілю",
  "onboarding.profile.upload_avatar": "Загрузіць фота профілю",
  "onboarding.profile.upload_header": "Загрузіць шапку профілю",
  "password_confirmation.exceeds_maxlength": "Пароль пацвярджэння перавышае максімальна дапушчальную даўжыню",
  "password_confirmation.mismatching": "Пароль пацьверджання не супадае",
  "picture_in_picture.restore": "Вярніце назад",
  "poll.closed": "Закрыта",
  "poll.refresh": "Абнавіць",
  "poll.reveal": "Паказаць вынікі",
  "poll.total_people": "{count, plural, one {# чалавек} few {# чалавекі} many {# чалавек} other {# чалавека}}",
  "poll.total_votes": "{count, plural, one {# голас} few {# галасы} many {# галасоў} other {# голасу}}",
  "poll.vote": "Прагаласаваць",
  "poll.voted": "Вы прагаласавалі за гэты адказ",
  "poll.votes": "{votes, plural, one {# голас} few {# галасы} many {# галасоў} other {# голасу}}",
  "poll_button.add_poll": "Дадаць апытанне",
  "poll_button.remove_poll": "Выдаліць апытанне",
  "privacy.change": "Змяніць прыватнасць допісу",
  "privacy.direct.long": "Усе згаданыя ў допісе",
  "privacy.direct.short": "Асабістае згадванне",
  "privacy.private.long": "Толькі вашыя падпісчыкі",
  "privacy.private.short": "Падпісчыкі",
  "privacy.public.long": "Усе, хто ёсць і каго няма ў Mastodon",
  "privacy.public.short": "Публічны",
  "privacy.quote.anyone": "{visibility}, цытаванні дазволеныя",
  "privacy.quote.disabled": "{visibility}, цытаванні адключаныя",
  "privacy.quote.limited": "{visibility}, абмежаваныя цытаванні",
  "privacy.unlisted.additional": "Паводзіць сябе гэтак жа, як і публічны, за выключэннем таго, што допіс не будзе адлюстроўвацца ў жывой стужцы, хэштэгах, аглядзе або ў пошуку Mastodon, нават калі Вы ўключылі бачнасць у пошуку ў наладах.",
  "privacy.unlisted.long": "Схаваны ад вынікаў пошуку Mastodon, трэндавага і публічных стужак",
  "privacy.unlisted.short": "Ціхі публічны",
  "privacy_policy.last_updated": "Адноўлена {date}",
  "privacy_policy.title": "Палітыка канфідэнцыйнасці",
  "quote_error.edit": "Нельга дадаваць цытаты пры рэдагаванні допісаў.",
  "quote_error.poll": "Нельга цытаваць з апытаннямі.",
  "quote_error.private_mentions": "Цытаванне не дазваляецца ў прамых узгадваннях.",
  "quote_error.quote": "За раз дазволена рабіць толькі адно цытаванне.",
  "quote_error.unauthorized": "Вы не ўвайшлі, каб цытаваць гэты допіс.",
  "quote_error.upload": "Нельга цытаваць з медыя далучэннямі.",
  "recommended": "Рэкамендаванае",
  "refresh": "Абнавiць",
  "regeneration_indicator.please_stand_by": "Пачакайце.",
  "regeneration_indicator.preparing_your_home_feed": "Рыхтуем вашу галоўную стужку…",
  "relative_time.days": "{number} д",
  "relative_time.full.days": "{number, plural, one {# дзень} few {# дні} many {# дзён} other {# дня}} таму",
  "relative_time.full.hours": "{number, plural, one {# гадзіна} few {# гадзіны} many {# гадзін} other {# гадзіны}} таму",
  "relative_time.full.just_now": "толькі што",
  "relative_time.full.minutes": "{number, plural, one {# хвіліна} few {# хвіліны} many {# хвілін} other {# хвіліны}} таму",
  "relative_time.full.seconds": "{number, plural, one {# секунда} few {# секунды} many {# секунд} other {# секунды}} таму",
  "relative_time.hours": "{number} гадз",
  "relative_time.just_now": "толькі што",
  "relative_time.minutes": "{number} хв",
  "relative_time.seconds": "{number} с",
  "relative_time.today": "сёння",
  "remove_quote_hint.button_label": "Зразумела",
  "remove_quote_hint.message": "Можаце зрабіце гэта ў {icon} меню налад.",
  "remove_quote_hint.title": "Хочаце выдаліць Ваш допіс з цытатай?",
  "reply_indicator.attachments": "{count, plural, one {# далучэнне} few {# далучэнні} many {# далучэнняў} other {# далучэння}}",
  "reply_indicator.cancel": "Скасаваць",
  "reply_indicator.poll": "Апытанне",
  "report.block": "Заблакіраваць",
  "report.block_explanation": "Вы перастанеце бачыць допісы гэтага карыстальніка. Ён не зможа сачыць за Вамі і бачыць Вашы допісы. Ён зможа зразумець, што яго заблакіравалі.",
  "report.categories.legal": "Звязанае з правам",
  "report.categories.other": "Іншае",
  "report.categories.spam": "Спам",
  "report.categories.violation": "Змест парушае адно ці некалькі правілаў сервера",
  "report.category.subtitle": "Выберыце найлепшае падабенства",
  "report.category.title_account": "Паведаміце нам, што не так з гэтым профілем",
  "report.category.title_collection": "Паведаміце нам, што не так з гэтай калекцыяй",
  "report.category.title_status": "Паведаміце нам, што не так з гэтым допісам",
  "report.close": "Гатова",
  "report.comment.title": "Што-небудзь яшчэ, што нам неабходна ведаць?",
  "report.forward": "Пераслаць на {target}",
  "report.forward_hint": "Гэты ўліковы запіс з іншага сервера. Даслаць ананімную копію скаргі і туды?",
  "report.mute": "Ігнараваць",
  "report.mute_explanation": "Вы не будзеце бачыць допісы гэтага карыстальніка. Ён усё яшчэ зможа сачыць за Вамі і бачыць Вашы допісы, не ведаючы, што яго ігнаруюць.",
  "report.next": "Далей",
  "report.placeholder": "Дадатковыя каментарыі",
  "report.reasons.dislike": "Мне ён не падабаецца",
  "report.reasons.dislike_description": "Гэта тое, што Вы не хочаце бачыць",
  "report.reasons.legal": "Гэта незаконна",
  "report.reasons.legal_description": "Вы лічыце, што гэта парушае заканадаўства вашай краіны або краіны сервера",
  "report.reasons.other": "Гэта нешта іншае",
  "report.reasons.other_description": "Гэта праблема не падпадае пад іншыя катэгорыі",
  "report.reasons.spam": "Гэта спам",
  "report.reasons.spam_description": "Шкодныя спасылкі, несапраўдныя ўзаемадзеянні, або адказы, што паўтараюцца",
  "report.reasons.violation": "Гэта парушае правілы сервера",
  "report.reasons.violation_description": "Вам вядома, што гэта парушае пэўныя правілы",
  "report.rules.subtitle": "Абярыце ўсе варыянты, што падыходзяць",
  "report.rules.title": "Якія правілы былі парушаны?",
  "report.statuses.subtitle": "Абярыце ўсе пункты, што падыходзяць",
  "report.statuses.title": "Ці ёсць допісы, каб падмацаваць гэтую скаргу?",
  "report.submission_error": "Немагчыма адправіць скаргу",
  "report.submission_error_details": "Калі ласка, праверце сваё сеткавае злучэнне і паспрабуйце зноў пазней.",
  "report.submit": "Адправіць",
  "report.target": "Скарга на {target}",
  "report.thanks.take_action": "Вось Вашыя варыянты кантролю над тым, што Вы бачыце в Mastodon:",
  "report.thanks.take_action_actionable": "Пакуль мы разглядаем яе, Вы можаце распачаць дзеянні супраць @{name}:",
  "report.thanks.title": "Ці хочаце Вы бачыць гэта?",
  "report.thanks.title_actionable": "Дзякуем за зварот, мы разбяромся з гэтым.",
  "report.unfollow": "Адпісацца ад @{name}",
  "report.unfollow_explanation": "Вы падпісаныя на гэты ўліковы запіс. Каб не бачыць допісы з яго ў вашай стужцы, адпішыцеся.",
  "report_notification.attached_statuses": "{count, plural, one {{count} допіс прымацаваны} few {{count} допісы прымацаваны} many {{count} допісаў прымацавана} other {{count} допісу прымацавана}}",
  "report_notification.categories.legal": "Права",
  "report_notification.categories.legal_sentence": "нелегальнае змесціва",
  "report_notification.categories.other": "Іншае",
  "report_notification.categories.other_sentence": "іншае",
  "report_notification.categories.spam": "Спам",
  "report_notification.categories.spam_sentence": "спам",
  "report_notification.categories.violation": "Парушэнне правілаў",
  "report_notification.categories.violation_sentence": "парушэнне правілаў",
  "report_notification.open": "Адкрыць скаргу",
  "search.clear": "Ачысціць пошук",
  "search.no_recent_searches": "Гісторыя пошуку пустая",
  "search.placeholder": "Пошук",
  "search.quick_action.account_search": "Супадзенне профіляў {x}",
  "search.quick_action.go_to_account": "Перайсці да профілю {x}",
  "search.quick_action.go_to_hashtag": "Перайсці да хэштэгу {x}",
  "search.quick_action.open_url": "Адкрыць спасылку ў Mastodon",
  "search.quick_action.status_search": "Супадзенне паведамленняў {x}",
  "search.search_or_paste": "Пошук",
  "search_popout.full_text_search_disabled_message": "Недаступна на {domain}.",
  "search_popout.full_text_search_logged_out_message": "Даступна толькі пры ўваходзе ў сістэму.",
  "search_popout.language_code": "ISO код мовы",
  "search_popout.options": "Параметры пошуку",
  "search_popout.quick_actions": "Хуткія дзеянні",
  "search_popout.recent": "Нядаўнія запыты",
  "search_popout.specific_date": "канкрэтная дата",
  "search_popout.user": "карыстальнік",
  "search_results.accounts": "Профілі",
  "search_results.all": "Усё",
  "search_results.collections": "Калекцыі",
  "search_results.hashtags": "Хэштэгі",
  "search_results.no_results": "Няма вынікаў.",
  "search_results.no_search_yet": "Паспрабуйце пашукаць допісы, профілі або хэштэгі.",
  "search_results.see_all": "Праглядзець усе",
  "search_results.statuses": "Допісы",
  "search_results.title": "Шукаць \"{q}\"",
  "server_banner.about_active_users": "Людзі, якія карысталіся гэтым серверам на працягу апошніх 30 дзён (штомесячна актыўныя карыстальнікі)",
  "server_banner.active_users": "актыўныя карыстальнікі",
  "server_banner.administered_by": "Адміністратар:",
  "server_banner.is_one_of_many": "{domain} - гэта адзін з многіх незалежных сервераў Mastodon, які Вы можаце выкарыстоўваць для ўдзелу ў федэральным сусвеце.",
  "server_banner.more_about_this_server": "Падрабязней пра гэты сервер",
  "server_banner.server_stats": "Статыстыка сервера:",
  "sign_in_banner.create_account": "Стварыць уліковы запіс",
  "sign_in_banner.follow_anyone": "Падпісвайцеся на каго захочаце ва ўсім федэральным сусвеце і глядзіце ўсё ў храналагічным парадку. Ніякіх алгарытмаў, рэкламы або клікбэйту.",
  "sign_in_banner.mastodon_is": "Mastodon - найлепшы спосаб быць у курсе ўсяго, што адбываецца.",
  "sign_in_banner.sign_in": "Увайсці",
  "sign_in_banner.sso_redirect": "Уваход ці рэгістрацыя",
  "skip_links.hotkey": "<span>Спалучэнне клавіш</span> {hotkey}",
  "skip_links.skip_to_content": "Перайсці да асноўнага зместу",
  "skip_links.skip_to_navigation": "Перайсці да асноўнай навігацыі",
  "status.admin_account": "Адкрыць інтэрфейс мадэратара для @{name}",
  "status.admin_domain": "Адкрыць інтэрфейс мадэратара для {domain}",
  "status.admin_status": "Адкрыць гэты допіс у інтэрфейсе мадэрацыі",
  "status.all_disabled": "Пашырэнні і цытаванні адключаны",
  "status.block": "Заблакіраваць @{name}",
  "status.bookmark": "Дадаць закладку",
  "status.cancel_reblog_private": "Прыбраць",
  "status.cannot_edit": "Вы не маеце дазвол рэдагаваць гэты допіс",
  "status.cannot_quote": "Вы не маеце дазвол цытаваць гэты допіс",
  "status.cannot_reblog": "Гэты допіс нельга пашырыць",
  "status.contains_quote": "Утрымлівае цытату",
  "status.context.loading": "Загружаюцца іншыя адказы",
  "status.context.loading_error": "Немагчыма загрузіць новыя адказы",
  "status.context.loading_success": "Новыя адказы загружаныя",
  "status.context.more_replies_found": "Знойдзеныя іншыя адказы",
  "status.context.retry": "Паспрабаваць зноў",
  "status.context.show": "Паказаць",
  "status.continued_thread": "Працяг ланцужка",
  "status.copy": "Скапіраваць спасылку на допіс",
  "status.delete": "Выдаліць",
  "status.delete.success": "Допіс быў выдалены",
  "status.detailed_status": "Дэтальны агляд размовы",
  "status.direct": "Згадаць асабіста @{name}",
  "status.direct_indicator": "Асабістае згадванне",
  "status.edit": "Рэдагаваць",
  "status.edited": "Апошняе рэдагаванне {date}",
  "status.edited_x_times": "Рэдагавана {count, plural, one {{count} раз} few {{count} разы} many {{count} разоў} other {{count} разу}}",
  "status.embed": "Атрымаць убудаваны код",
  "status.favourite": "Упадабанае",
  "status.favourites_count": "{count, plural, one {{counter} упадабанне} few {{counter} упадабанні} many {{counter} упадабанняў} other {{counter} упадабанняў}}",
  "status.filter": "Фільтраваць гэты допіс",
  "status.history.created": "Створана {name} {date}",
  "status.history.edited": "Адрэдагавана {name} {date}",
  "status.load_more": "Загрузіць яшчэ",
  "status.media.open": "Націсніце, каб адкрыць",
  "status.media.show": "Націсніце, каб паказаць",
  "status.media_hidden": "Медыя схаваныя",
  "status.mention": "Згадаць @{name}",
  "status.more": "Больш",
  "status.mute": "Ігнараваць @{name}",
  "status.mute_conversation": "Ігнараваць размову",
  "status.not_quoted": "Вас не цытавалі ў гэтым допісе",
  "status.open": "Разгарнуць гэты допіс",
  "status.pin": "Замацаваць у профілі",
  "status.public_only": "Гэты допіс прыватны",
  "status.quote": "Цытаваць",
  "status.quote.cancel": "Адмяніць цытаванне",
  "status.quote_error.blocked_account_hint.title": "Гэты допіс схаваны, бо Вы заблакіравалі @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Гэты допіс схаваны, бо Вы заблакіравалі @{domain}.",
  "status.quote_error.filtered": "Схавана адным з Вашых фільтраў",
  "status.quote_error.limited_account_hint.action": "Усё адно паказаць",
  "status.quote_error.limited_account_hint.title": "Гэты ўліковы запіс быў схаваны мадэратарамі {domain}.",
  "status.quote_error.muted_account_hint.title": "Гэты допіс схаваны, бо Вы вырашылі ігнараваць @{name}.",
  "status.quote_error.not_available": "Допіс недаступны",
  "status.quote_error.pending_approval": "Допіс чакае пацвярджэння",
  "status.quote_error.pending_approval_popout.body": "У Mastodon можна кантраляваць магчымасць іншых цытаваць Вас. Гэты допіс будзе знаходзіцца ў стане чакання, пакуль мы не атрымаем ухваленне на цытаванне ад аўтара арыгінальнага допісу.",
  "status.quote_error.revoked": "Аўтар выдаліў допіс",
  "status.quote_followers_only": "Толькі падпісчыкі могуць цытаваць гэты допіс",
  "status.quote_manual_review": "Аўтар зробіць агляд уручную",
  "status.quote_noun": "Цытаваць",
  "status.quote_policy_change": "Змяніць, хто можа цытаваць",
  "status.quote_post_author": "Цытаваў(-ла) допіс @{name}",
  "status.quote_private": "Прыватныя допісы нельга цытаваць",
  "status.quotes.empty": "Яшчэ ніхто не цытаваў гэты допіс. Калі гэта адбудзецца, то Вы пабачыце гэта тут.",
  "status.quotes.local_other_disclaimer": "Цытаты, у якіх адмовіў аўтар, паказаныя не будуць.",
  "status.quotes.remote_other_disclaimer": "Толькі цытаты з {domain} тут будуць гарантавана паказаныя. Цытаты, у якіх адмовіў аўтар, паказаныя не будуць.",
  "status.quotes_count": "{count, plural, one {{counter} цытаванне} few {{counter} цытаванні} many {{counter} цытаванняў} other {{counter} цытаванняў}}",
  "status.read_more": "Чытаць болей",
  "status.reblog": "Пашырыць",
  "status.reblog_or_quote": "Пашырыць ці цытаваць",
  "status.reblog_private": "Зноў падзяліцца са сваімі падпісчыкамі",
  "status.reblogged_by": "{name} пашырыў(-ла)",
  "status.reblogs.empty": "Гэты допіс яшчэ ніхто не пашырыў. Калі гэта адбудзецца, гэтых людзей будзе бачна тут.",
  "status.reblogs_count": "{count, plural, one {{counter} пашырэнне} few {{counter} пашырэнні} many {{counter} пашырэнняў} other {{counter} пашырэнняў}}",
  "status.redraft": "Выдаліць і перапісаць",
  "status.remove_bookmark": "Выдаліць закладку",
  "status.remove_favourite": "Выдаліць з упадабаных",
  "status.remove_quote": "Выдаліць",
  "status.replied_in_thread": "Адказаў(-ла) у ланцужку",
  "status.replied_to": "Адказаў(-ла) {name}",
  "status.reply": "Адказаць",
  "status.replyAll": "Адказаць у ланцугу",
  "status.report": "Паскардзіцца на @{name}",
  "status.request_quote": "Даслаць запыт на цытаванне",
  "status.revoke_quote": "Выдаліць мой допіс з допісу @{name}",
  "status.sensitive_warning": "Адчувальнае змесціва",
  "status.share": "Абагуліць",
  "status.show_less_all": "Згарнуць усё",
  "status.show_more_all": "Разгарнуць усё",
  "status.show_original": "Паказаць арыгінал",
  "status.title.with_attachments": "{user} апублікаваў {attachmentCount, plural, one {далучэнне} few {{attachmentCount} далучэнні} many {{attachmentCount} далучэнняў} other {{attachmentCount} далучэння}}",
  "status.translate": "Перакласці",
  "status.translated_from_with": "Перакладзена з {lang} з дапамогай {provider}",
  "status.uncached_media_warning": "Перадпрагляд недаступны",
  "status.unmute_conversation": "Не ігнараваць размову",
  "status.unpin": "Адмацаваць ад профілю",
  "subscribed_languages.lead": "Толькі допісы ў абраных мовах будуць паказвацца ў вашых стужках пасля змены. Не абірайце нічога, каб бачыць допісы на ўсіх мовах.",
  "subscribed_languages.save": "Захаваць змены",
  "subscribed_languages.target": "Змяніць мовы падпіскі для {target}",
  "tabs_bar.home": "Галоўная",
  "tabs_bar.menu": "Меню",
  "tabs_bar.notifications": "Апавяшчэнні",
  "tabs_bar.publish": "Новы допіс",
  "tabs_bar.quick_links": "Хуткія спасылкі",
  "tabs_bar.search": "Пошук",
  "tag.remove": "Выдаліць",
  "terms_of_service.effective_as_of": "Дзейнічае да {date}",
  "terms_of_service.title": "Умовы выкарыстання",
  "terms_of_service.upcoming_changes_on": "Змены, якія адбудуцца {date}",
  "time_remaining.days": "{number, plural, one {застаўся # дзень} few {засталося # дні} many {засталося # дзён} other {засталося # дня}}",
  "time_remaining.hours": "{number, plural, one {засталася # гадзіна} few {засталося # гадзіны} many {засталося # гадзін} other {засталося # гадзіны}}",
  "time_remaining.minutes": "{number, plural, one {засталася # хвіліна} few {засталося # хвіліны} many {засталося # хвілін} other {засталося # хвіліны}}",
  "time_remaining.moments": "Засталося некалькі секунд",
  "time_remaining.seconds": "{number, plural, one {засталася # секунда} few {засталося # секунды} many {засталося # секунд} other {засталося # секунды}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} чалавек} few {{counter} чалавекі} many {{counter} людзей} other {{counter} чалавек}} за {days, plural, one {{days} апошні дзень} few {{days} апошнія дні} many {{days} апошніх дзён} other {{days} апошніх дзён}}",
  "trends.trending_now": "Актуальнае",
  "ui.beforeunload": "Ваш чарнавік будзе страчаны, калі Вы пакінеце Mastodon.",
  "units.short.billion": "{count} млрд.",
  "units.short.million": "{count} міл.",
  "units.short.thousand": "{count} тыс.",
  "upload_area.title": "Перацягніце сюды для загрузкі",
  "upload_button.label": "Дадаць выяву, відэа- ці аўдыяфайл",
  "upload_error.limit": "Перавышана колькасць файлаў.",
  "upload_error.poll": "Немагчыма прымацаваць файл да апытання.",
  "upload_error.quote": "Нельга запампоўваць файл пры цытаванні.",
  "upload_form.drag_and_drop.instructions": "Каб абраць медыя ўлажэнне, націсніце прабел ці Enter. Падчас перасоўвання выкарыстоўвайце кнопкі са стрэлкамі, каб пасунуць медыя далучэнне ў любым напрамку. Націсніце прабел ці Enter зноў, каб перасунуць медыя далучэнне ў новае месца, або Escape для адмены.",
  "upload_form.drag_and_drop.on_drag_cancel": "Перасоўванне адмененае. Медыя ўлажэнне {item} на месцы.",
  "upload_form.drag_and_drop.on_drag_end": "Медыя ўлажэнне {item} на месцы.",
  "upload_form.drag_and_drop.on_drag_over": "Медыя ўлажэнне {item} перасунутае.",
  "upload_form.drag_and_drop.on_drag_start": "Абранае медыя ўлажэнне {item}.",
  "upload_form.edit": "Рэдагаваць",
  "upload_progress.label": "Запампоўванне...",
  "upload_progress.processing": "Апрацоўка…",
  "username.taken": "Гэта імя карыстальніка занята. Паспрабуйце іншае",
  "video.close": "Закрыць відэа",
  "video.download": "Спампаваць файл",
  "video.exit_fullscreen": "Выйсці з поўнаэкраннага рэжыму",
  "video.expand": "Разгарнуць відэа",
  "video.fullscreen": "Увесь экран",
  "video.hide": "Схаваць відэа",
  "video.mute": "Выключыць гук",
  "video.pause": "Паўза",
  "video.play": "Прайграць",
  "video.skip_backward": "Праматаць назад",
  "video.skip_forward": "Праматаць уперад",
  "video.unmute": "Уключыць гук",
  "video.volume_down": "Паменшыць гучнасць",
  "video.volume_up": "Павялічыць гучнасць",
  "visibility_modal.button_title": "Вызначыць бачнасць",
  "visibility_modal.direct_quote_warning.text": "Калі Вы захавайце бягучыя налады, прымацаваная цытата будзе пераробленая ў спасылку.",
  "visibility_modal.direct_quote_warning.title": "Цытаты нельга далучаць да прыватных узгадванняў",
  "visibility_modal.header": "Бачнасць і ўзаемадзеянне",
  "visibility_modal.helper.direct_quoting": "Прыватныя згадванні, створаныя на Mastodon, нельга цытаваць іншым людзям.",
  "visibility_modal.helper.privacy_editing": "Бачнасць нельга змяніць у апублікаваным допісе.",
  "visibility_modal.helper.privacy_private_self_quote": "Самацытаванне прыватных допісаў не можа быць публічным.",
  "visibility_modal.helper.private_quoting": "Допісы для падпісчыкаў, створаныя на Mastodon, нельга цытаваць іншым людзям.",
  "visibility_modal.helper.unlisted_quoting": "Калі людзі працытуюць Вас, іх допіс таксама будзе схаваны ад стужкі трэндаў.",
  "visibility_modal.instructions": "Кантралюйце, хто можа ўзаемадзейнічаць з гэтым допісам. Вы таксама можаце ўжыць налады для ўсіх будучых допісаў, перайшоўшы ў <link>Налады > Публікаваць па змаўчанні </link>.",
  "visibility_modal.privacy_label": "Бачнасць",
  "visibility_modal.quote_followers": "Толькі падпісчыкі",
  "visibility_modal.quote_label": "Хто можа цытаваць",
  "visibility_modal.quote_nobody": "Толькі я",
  "visibility_modal.quote_public": "Усе",
  "visibility_modal.save": "Захаваць"
}
